import React, { useRef, useState, useEffect } from 'react';
import {
  Grid,
  MenuItem,
  TextField,
  Typography,
  InputLabel,
  Box,
  Card,
  Select,
  Icon,
} from '@mui/material';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "trainingCompanyRoutes";
import editRoutes from "trainingCompanyEditRoutes";
import Container from "@mui/material/Container";
import MKBox from "components/MKBox";
import CountryList from 'country-list-with-dial-code-and-flag';
import Logo from "assets/images/skill2.png";
import CompanyIcon from "assets/images/companyicon.png";
import Expectation from "assets/images/team_3082743.png";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import MKButton from "components/MKButton";
import { LocationOn } from '@mui/icons-material';
import MKTypography from "components/MKTypography";
import MKAvatar from "components/MKAvatar";
import SimpleFooter from "examples/Footers/SimpleFooter";
import { useNavigate } from 'react-router-dom';
import MKAlert from "components/MKAlert";
import Modal from "@mui/material/Modal";
import MKInput from 'components/MKInput';
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import AWS from 'aws-sdk';
import TrainingCompanyTermsAndCondition from './TrainingCompanyTermsAndCondition';
import FormControl from '@mui/material/FormControl';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import '../../../styles.css';
import IdleTimeOutHandler from "pages/IdleTimeHandler/IdleTimeOutHander";

const LoadingOverlay = ({ loading, children }) => {
  return (
    <>
      {loading && (
        <Backdrop
          sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            filter: 'blur(5px)',
            pointerEvents: 'none',
          }}
          open={loading}
        >
          <Box
            sx={{
              position: "absolute",
              top: "0",
              left: "0",
              zIndex: "1",
              width: "100%",
              minHeight: "100vh",
              // display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none',
              userSelect: 'none',
            }}
          >
            {children}
          </Box>
        </Backdrop>
      )}
      {loading && (
        <Box
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: (theme) => theme.zIndex.drawer + 2,
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {!loading && children}
    </>
  );
};

const Page = () => {
  const [scroll, setScroll] = React.useState("paper");
  const [agreed, setAgreed] = useState(false);
  const [submitCompleted, setSubmitCompleted] = useState(false);
  const [mobileNumber, setMobileNumber] = useState('');
  const [submitMobileCompleted, setSubmitMobileCompleted] = useState(false);
  const [submitOTPCompleted, setSubmitOTPCompleted] = useState(false);
  const [otpValidated, setOtpValidated] = useState(false);
  const [otpValue, setOtpValue] = useState('');
  const [bbdata, setbbdata] = useState([]);
  const [userId, setUserId] = useState("");
  const [dialogCountry, setDialogCountry] = useState('');
  const [dialogCountryCode, setDialogCountryCode] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [resendDisabled, setResendDisabled] = useState(false);
  const [timer, setTimer] = useState(120);
  const [trainingCompanyProfileCreate, setTrainingCompanyProfileCreate] = useState(false);
  const [trainerList, setTrainerList] = useState([]);
  const [bb1data, setbb1Data] = useState([]);
  const [submitAcceptCompleted, setSubmitAcceptCompleted] = useState(false);
  const [submitStartTrainingCompleted, setSubmitStartTrainingCompleted] = useState(false);
  const [submitFeedbackCompleted, setSubmitFeedbackCompleted] = useState(false);
  const [submitPaymentCompleted, setSubmitPaymentCompleted] = useState(false);
  const [mobileNumberError, setMobileNumberError] = useState(true);
  const [submitPaymentConfirmationCompleted, setSubmitPaymentConfirmationCompleted] = useState(false);
  const [submitNewPaymentDateCompleted, setSubmitNewPaymentDateCompleted] = useState(false);

  const [emailVerified, setEmailVerified] = useState(false);
  const [mobVerified, setMobVerified] = useState(false);
  const [tcVerified, setTcVerified] = useState(false);

  const [activeTrainingDetails, setActiveTrainingDetails] = useState([]);
  const [trainerRecruitDetails, setTrainerRecruitDetails] = useState([]);
  const [recommendedSkillsDetails, setRecommendedSkillsDetails] = useState([]);
  const [skillErrorMessage, setSkillErrorMessage] = useState('');
  const [recruitSubmitCompleted, setRecruitSubmitCompleted] = useState(false);
  const [selectedTrainer, setSelectedTrainer] = useState([]);

  const [selectedCountry, setSelectedCountry] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [avatarBackgroundColor, setAvatarBackgroundColor] = useState('#ccc');
  const [responseFromDB, setResponseFromDB] = useState("");
  const [submitRemainderCompleted, setSubmitRemainderCompleted] = useState(false);
  const [maxRemainderCount, setMaxRemainderCount] = useState(false);
  const [maxRecruitCount, setMaxRecruitCount] = useState(false);
  const [responseRecruitFromDB, setResponseRecruitFromDB] = useState("");
  const [trainingDetails, setTrainingDetails] = useState([]);
  const [feedbackQuestions, setFeedbackQuestions] = useState([]);
  const [feedbackRating, setFeedbackRating] = useState(0);
  const [isFeedback1Interacted, setIsFeedback1Interacted] = useState(false);
  const [feedbackAnswer1, setFeedbackAnswer1] = useState("");
  const [isFeedback2Interacted, setIsFeedback2Interacted] = useState(false);
  const [feedbackAnswer2, setFeedbackAnswer2] = useState("");
  const [isFeedback3Interacted, setIsFeedback3Interacted] = useState(false);
  const [feedbackAnswer3, setFeedbackAnswer3] = useState("");
  const [isFeedback4Interacted, setIsFeedback4Interacted] = useState(false);
  const [feedbackAnswer4, setFeedbackAnswer4] = useState("");
  const [isFeedback5Interacted, setIsFeedback5Interacted] = useState(false);
  const [feedbackAnswer5, setFeedbackAnswer5] = useState("");
  const [isFeedback6Interacted, setIsFeedback6Interacted] = useState(false);
  const [feedbackAnswer6, setFeedbackAnswer6] = useState("");
  const [isFeedback7Interacted, setIsFeedback7Interacted] = useState(false);
  const [feedbackAnswer7, setFeedbackAnswer7] = useState("");
  const [isFeedback8Interacted, setIsFeedback8Interacted] = useState(false);
  const [feedbackAnswer8, setFeedbackAnswer8] = useState("");
  const [feedbackStatusAvailable, setFeedbackStatusAvailable] = useState(false);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [pendingAction, setPendingAction] = useState([]);
  const [loading, setLoading] = useState(false);
  const [trainingCompanyProfileDetails, setTrainingCompanyProfileDetails] = useState([])

  useEffect(() => {
    let id = localStorage.getItem("userId");
    fetch(`${process.env.REACT_APP_API_URL}/api/training-companyprofile-filter/${id}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setTrainingCompanyProfileDetails(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  console.log("trainingCompanyProfileDetails", trainingCompanyProfileDetails);

  const handleCountryChange = (event) => {
    const selectedCountry = event.target.value;
    setSelectedCountry(selectedCountry);
    const country = CountryList.getAll().find((c) => c.name === selectedCountry);
    if (country) {
      setCountryCode(country.dialCode);
    }
    setDialogCountry(selectedCountry);
    setDialogCountryCode(country ? country.dial_code : '');
  };

  // const handlePostedScroll = (direction) => {
  //   const container = document.getElementById('posted-training-list-container');
  //   const scrollAmount = direction === 'left' ? -600 : 600;
  //   container.scrollBy({
  //     left: scrollAmount,
  //     behavior: 'smooth',
  //   });
  // };

  const [postedCurrentSlide, setPostedCurrentSlide] = useState(0);
  const handlePostedScroll = (direction) => {
    console.log("lklklklk");

    // if(postedTrainingDetails.length <=5) {
    //   const totalSlides = Math.ceil(postedTrainingDetails.length / 2);
    // } else {
    //   const totalSlides = 5;
    // }
    // const totalSlides = 5;
    const totalSlides = Math.ceil(postedTrainingDetails.length / 2);
    if (direction === 'left') {
      setPostedCurrentSlide((prevSlide) => (prevSlide === 0 ? totalSlides - 1 : prevSlide - 1));
    } else {
      setPostedCurrentSlide((prevSlide) => (prevSlide === totalSlides - 1 ? 0 : prevSlide + 1));
    }
  };

  // const handleActiveScroll = (direction) => {
  //   const container = document.getElementById('active-training-list-container');
  //   const scrollAmount = direction === 'left' ? -600 : 600;
  //   container.scrollBy({
  //     left: scrollAmount,
  //     behavior: 'smooth',
  //   });
  // };

  const [activeCurrentSlide, setActiveCurrentSlide] = useState(0);
  const handleActiveScroll = (direction) => {
    const totalSlides = Math.ceil(appliedTrainingDetails.length / 2);
    if (direction === 'left') {
      setActiveCurrentSlide((prevSlide) => (prevSlide === 0 ? totalSlides - 1 : prevSlide - 1));
    } else {
      setActiveCurrentSlide((prevSlide) => (prevSlide === totalSlides - 1 ? 0 : prevSlide + 1));
    }
  };

  // const handleCompletedScroll = (direction) => {
  //   const container = document.getElementById('completed-training-list-container');
  //   const scrollAmount = direction === 'left' ? -600 : 600;
  //   container.scrollBy({
  //     left: scrollAmount,
  //     behavior: 'smooth',
  //   });
  // };

  const [completedCurrentSlide, setCompletedCurrentSlide] = useState(0);
  const handleCompletedScroll = (direction) => {
    const totalSlides = Math.ceil(completedTrainingDetails.length / 2);
    if (direction === 'left') {
      setCompletedCurrentSlide((prevSlide) => (prevSlide === 0 ? totalSlides - 1 : prevSlide - 1));
    } else {
      setCompletedCurrentSlide((prevSlide) => (prevSlide === totalSlides - 1 ? 0 : prevSlide + 1));
    }
  };


  // const handleCancelledScroll = (direction) => {
  //   const container = document.getElementById('cancelled-training-list-container');
  //   const scrollAmount = direction === 'left' ? -600 : 600;
  //   container.scrollBy({
  //     left: scrollAmount,
  //     behavior: 'smooth',
  //   });
  // };

  const [cancelledCurrentSlide, setCancelledCurrentSlide] = useState(0);
  const handleCancelledScroll = (direction) => {
    const totalSlides = Math.ceil(cancelledTrainingDetails.length / 2);
    if (direction === 'left') {
      setCancelledCurrentSlide((prevSlide) => (prevSlide === 0 ? totalSlides - 1 : prevSlide - 1));
    } else {
      setCancelledCurrentSlide((prevSlide) => (prevSlide === totalSlides - 1 ? 0 : prevSlide + 1));
    }
  };

  useEffect(() => {
    const container = document.getElementById('active-training-list-container');
    if (container) {
      container.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          handleActiveScroll('left');
        } else if (e.key === 'ArrowRight') {
          handleActiveScroll('right');
        }
      });
    }
  }, []);


  useEffect(() => {
    const container = document.getElementById('posted-training-list-container');
    if (container) {
      container.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          handlePostedScroll('left');
        } else if (e.key === 'ArrowRight') {
          handlePostedScroll('right');
        }
      });
    }
  }, []);

  useEffect(() => {
    const container = document.getElementById('completed-training-list-container');
    if (container) {
      container.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          handleCompletedScroll('left');
        } else if (e.key === 'ArrowRight') {
          handleCompletedScroll('right');
        }
      });
    }
  }, []);

  useEffect(() => {
    const container = document.getElementById('cancelled-training-list-container');
    if (container) {
      container.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          handleCancelledScroll('left');
        } else if (e.key === 'ArrowRight') {
          handleCancelledScroll('right');
        }
      });
    }
  }, []);


  // const handleRecommendedScroll = (direction) => {
  //   const container = document.getElementById('recommended-training-list-container');
  //   const scrollAmount = direction === 'left' ? -700 : 700;
  //   container.scrollBy({
  //     left: scrollAmount,
  //     behavior: 'smooth',
  //   });
  // };
  const [recommendedCurrentSlide, setRecommendedCurrentSlide] = useState(0);
  const handleRecommendedScroll = (direction) => {
    const totalSlides = Math.ceil(recommendedSkillsDetails.length / 2);
    if (direction === 'left') {
      setRecommendedCurrentSlide((prevSlide) => (prevSlide === 0 ? totalSlides - 1 : prevSlide - 1));
    } else {
      setRecommendedCurrentSlide((prevSlide) => (prevSlide === totalSlides - 1 ? 0 : prevSlide + 1));
    }
  };


  useEffect(() => {
    const container = document.getElementById('recommended-training-list-container');
    if (container) {
      container.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          handleRecommendedScroll('left');
        } else if (e.key === 'ArrowRight') {
          handleRecommendedScroll('right');
        }
      });
    }
  }, []);

  const [recruitCurrentSlide, setRecruitCurrentSlide] = useState(0);
  const handleRecuritScroll = (direction) => {
    const totalSlides = Math.ceil(trainerRecruitDetails.length / 2);
    if (direction === 'left') {
      setRecruitCurrentSlide((prevSlide) => (prevSlide === 0 ? totalSlides - 1 : prevSlide - 1));
    } else {
      setRecruitCurrentSlide((prevSlide) => (prevSlide === totalSlides - 1 ? 0 : prevSlide + 1));
    }
  };

  // const handleRecuritScroll = (direction) => {
  //   const container = document.getElementById('recurit-training-list-container');
  //   const scrollAmount = direction === 'left' ? -600 : 600;
  //   container.scrollBy({
  //     left: scrollAmount,
  //     behavior: 'smooth',
  //   });
  // };

  useEffect(() => {
    const container = document.getElementById('recurit-training-list-container');
    if (container) {
      container.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          handleRecuritScroll('left');
        } else if (e.key === 'ArrowRight') {
          handleRecuritScroll('right');
        }
      });
    }
  }, []);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/trainer-filter/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setbb1Data(data);
          setTrainerList(data.results);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  console.log("trainerList", trainerList);
  console.log("data", bb1data);

  const OnOkClick = (e) => {
    const data = {
      is_verified_tc: agreed,
    };
    fetch(`${process.env.REACT_APP_API_URL}/api/verifytc/${userId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          console.log("new1submitCompleted", submitCompleted);
          setSubmitCompleted(false);
        }
        return response.json();
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo");
      });

    console.log('Form submitted!');
  };
  console.log("newsubmitCompleted", submitCompleted);

  console.log(agreed);

  const handleMobNumSubmit = () => {
    setLoading(true);
    const data = {
      mobile_number: countryCode + mobileNumber,
      // mobile_number: mobileNumber,
      user_id: userId,
    };
    fetch(`${process.env.REACT_APP_API_URL}/api/send-otp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          console.log('aaaaaaaaaaa');
          setSubmitOTPCompleted(true);
        }
        setLoading(false);
        return response.json();
      })
      .then((data) => {
        setErrorMsg(data.message);
        console.log(data.message);
        console.log('fffffffffffffffff');
      })
      .catch((error) => {
        console.log('oooooooooooooooo');
      });
  };

  const handleValidateSubmit = () => {
    setLoading(true);
    const data = {
      mobile_number: countryCode + mobileNumber,
      // mobile_number: mobileNumber,
      otp: otpValue,
      user_id: userId,
    };
    fetch(`${process.env.REACT_APP_API_URL}/api/verify-otp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          console.log('aaaaaaaaaaa');
          setSubmitMobileCompleted(false);
          setOtpValidated(true);
        }
        setLoading(false);
        return response.json();
      })
      .then((data) => {
        console.log(data);
        setErrorMsg(data.message);
        console.log('fffffffffffffffff');
      })
      .catch((error) => {
        console.log('oooooooooooooooo');
      });
  };

  useEffect(() => {
    let id = localStorage.getItem("userId");
    setUserId(id);
    fetch(`${process.env.REACT_APP_API_URL}/api/userdetails/${id}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setbbdata(data);
          setEmailVerified(data.is_verified);
          setMobVerified(data.is_verified_mobile);
          setTcVerified(data.is_verified_tc);
          if (JSON.parse(data.is_verified_tc) === false) {
            setSubmitCompleted(true);
            console.log("HI");
          } else if (JSON.parse(data.is_verified_tc) === true) {
            console.log("222222");
            setSubmitCompleted(false);
            if (JSON.parse(data.is_verified_mobile) === false) {
              console.log("333333");
              setSubmitMobileCompleted(true);
            }
            else {
              console.log("44444444");
              setSubmitMobileCompleted(false);
            }
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [localStorage.getItem("token"), submitCompleted]);
  console.log(bbdata);
  console.log("submitCompleted", submitCompleted);
  console.log("submitMobileCompleted", submitMobileCompleted);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/feedback-template-view/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          const trainerFeedbackQuestions = data.filter(
            (question) => question.toWhom === "TrainingCompany"
          );
          setFeedbackQuestions(trainerFeedbackQuestions);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleRatingChange = (event, newValue) => {
    setFeedbackRating(newValue);
  };

  const onSubmitFeebackClick = (trainer) => {
    setLoading(true);
    console.log("111111111111111111", trainer);
    const data = {
      trainerID: trainer.apply_training.appliedTrainerID,
      trainingCompanyID: trainer.apply_training.trainingCompanyUserID,
      trainingID: trainer.apply_training.selectedTrainingID,
      toWhom: "Trainer",
      rating1: feedbackRating,
      question1: feedbackAnswer1,
      question2: feedbackAnswer2,
      question3: feedbackAnswer3,
      question4: feedbackAnswer4,
      question5: feedbackAnswer5,
      question6: feedbackAnswer6,
      question7: feedbackAnswer7,
      question8: feedbackAnswer8,
      status: "Active",
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/feedback-api-view/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setTrainerWithStatus7Modal(false);
          setFeedbackStatusAvailable(false);
          setSubmitFeedbackCompleted(true);
          setLoading(false);
        } else {
          setFeedbackStatusAvailable(true);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  console.log("feedbackStatus", feedbackStatusAvailable);

  useEffect(() => {
    if (submitOTPCompleted && !otpValidated) {
      startTimer();
    }
  }, [submitOTPCompleted, otpValidated]);

  const startTimer = () => {
    let timeLeft = 60; // 2 minutes (in seconds)
    setTimer(timeLeft);

    const timerInterval = setInterval(() => {
      timeLeft -= 1;
      setTimer(timeLeft);

      if (timeLeft === 0) {
        clearInterval(timerInterval);
        setResendDisabled(false);
      }
    }, 1000);

    setResendDisabled(true);
  };

  function formatTime(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const formattedTime = `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    return formattedTime;
  }

  const handleResendOTP = () => {
    const data = {
      mobile_number: countryCode + mobileNumber,
      user_id: userId,
    };
    fetch(`${process.env.REACT_APP_API_URL}/api/resend-otp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          console.log('aaaaaaaaaaa');
          // setSubmitOTPCompleted(true);
        }
        return response.json();
      })
      .then((data) => {
        setErrorMsg(data.message);
        console.log(data.message);
        console.log('fffffffffffffffff');
      })
      .catch((error) => {
        console.log('oooooooooooooooo');
      });
  };

  const handleMobileNumberChange = (e, setValidation) => {
    const input = e.target.value;
    const regex = /^[0-9]+$/;
    const isValid = regex.test(input);
    setMobileNumberError(isValid);
  };

  const handleDialogClose = () => {
    window.location.reload();
  };

  const handleOTPDialogClose = () => {
    fetch(`${process.env.REACT_APP_API_URL}/api/trainingcompanyprofileuidexists/${userId}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then(response => response.json())
      .then(data => {
        if (data.exists === false) {
          setSubmitOTPCompleted(false);
          setTrainingCompanyProfileCreate(true);
          window.location.href = "/app/trainingcompanyprofile";
        } else {
          setTrainingCompanyProfileCreate(false);
          window.location.reload();
        }
      })
      .catch(error => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    fetch(`${process.env.REACT_APP_API_URL}/api/trainingcompanyprofileuidexists/${id}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.exists === false && mobVerified === true && tcVerified === true && emailVerified === true) {
          setTrainingCompanyProfileCreate(true);
          window.location.href = "/app/trainingcompanyprofile";
        } else {
          setTrainingCompanyProfileCreate(false);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [localStorage.getItem("userId"), mobVerified, tcVerified, emailVerified]);
  console.log("trainingCompanyProfileCreate", trainingCompanyProfileCreate);

  const [postedTrainingDetails, setPostedTrainingDetails] = useState([]);
  const [appliedTrainingDetails, setAppliedTrainingDetails] = useState([]);
  const [completedTrainingDetails, setCompletedTrainingDetails] = useState([]);
  const [cancelledTrainingDetails, setCancelledTrainingDetails] = useState([]);

  // useEffect(() => {
  //   let id = localStorage.getItem("userId");
  //   console.log(id);
  //   let display = "nocard";
  //   fetch(`${process.env.REACT_APP_API_URL}/api/dashboard-active-training/${id}/${display}`, {
  //     method: 'GET',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       Authorization: 'Bearer ' + localStorage.getItem('token'),
  //     },
  //   })
  //     .then((resp) => resp.json())
  //     .then((data) => {
  //       if (!data.detail) {
  //         const trainingArray = Array.isArray(data) ? data : [];
  //         setActiveTrainingDetails(trainingArray);

  //         let appliedTrainingArray = [];
  //         let completedTrainingArray = [];

  //         trainingArray.forEach((training) => {
  //           fetch(`${process.env.REACT_APP_API_URL}/api/active-trainer-list/${training.id}/`, {
  //             method: 'GET',
  //             headers: {
  //               'Content-Type': 'application/json',
  //               Authorization: 'Bearer ' + localStorage.getItem('token'),
  //             },
  //           })
  //             .then((resp) => resp.json())
  //             .then((trainerData) => {
  //               if (training.status === "21") {
  //                 if (cancelledTrainingDetails.length < 5) {
  //                   setCancelledTrainingDetails((prevDetails) => [...prevDetails, training]);
  //                 }
  //               } else {
  //                 if (trainerData.length === 0) {
  //                   if (postedTrainingDetails.length < 5) {
  //                     setPostedTrainingDetails((prevDetails) => [...prevDetails, training]);
  //                   }
  //                 } else {
  //                   if (training.status === "11") {
  //                     if (completedTrainingDetails.length < 5) {
  //                       setCompletedTrainingDetails((prevDetails) => [...prevDetails, training]);
  //                     }
  //                   } else {
  //                     if (appliedTrainingDetails.length < 5) {
  //                       setAppliedTrainingDetails((prevDetails) => [...prevDetails, training]);
  //                     }
  //                   }
  //                 }
  //               }
  //             })
  //             .catch((error) => {

  //               console.error(error);
  //             });
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     });
  // }, [localStorage.getItem("userId")]);

  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    let display = "card";
    fetch(`${process.env.REACT_APP_API_URL}/api/dashboard-active-training/${id}/${display}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        console.log("data111111122222222222", data);

        if (data && data[0] && data[0].apply_data && data[0].apply_data.length > 0) {
          data[0].apply_data.forEach((applyTrainings) => {
            setAppliedTrainingDetails((prevDetails) => [...prevDetails, applyTrainings]);
          })
        }

        if (data && data[0] && data[0].completed_training_data && data[0].completed_training_data.length > 0) {
          data[0].completed_training_data.forEach((completed_trainings) => {
            setCompletedTrainingDetails((prevDetails) => [...prevDetails, completed_trainings]);
          })
        }

        if (data && data[0] && data[0].canceled_training_array && data[0].canceled_training_array.length > 0) {
          data[0].canceled_training_array.forEach((cancelled_trainings) => {
            setCancelledTrainingDetails((prevDetails) => [...prevDetails, cancelled_trainings]);
          })
        }

        if (data && data[0] && data[0].posted_training_array && data[0].posted_training_array.length > 0) {
          data[0].posted_training_array.forEach((posted_trainings) => {
            setPostedTrainingDetails((prevDetails) => [...prevDetails, posted_trainings]);
          })
        }

      })
      .catch((error) => {
        console.error(error);
      });
  }, [localStorage.getItem("userId")]);

  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    let display = "nocard"
    fetch(`${process.env.REACT_APP_API_URL}/api/dashboard-active-training-pending/${id}/${display}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          const trainingArray = Array.isArray(data) ? data : [];
          setActiveTrainingDetails(trainingArray);

          // let appliedTrainingArray = [];
          // let completedTrainingArray = [];

          // trainingArray.forEach((training) => {
          //   fetch(`${process.env.REACT_APP_API_URL}/api/active-trainer-list/${training.id}/`, {
          //     method: 'GET',
          //     headers: {
          //       'Content-Type': 'application/json',
          //       Authorization: 'Bearer ' + localStorage.getItem('token'),
          //     },
          //   })
          //     .then((resp) => resp.json())
          //     .then((trainerData) => {
          //       if (trainerData.length === 0) {
          //         setPostedTrainingDetails((prevDetails) => [...prevDetails, training]);
          //       } else {
          //         if (training.status === "11") {
          //           setCompletedTrainingDetails((prevDetails) => [...prevDetails, training]);
          //         } else {
          //           setAppliedTrainingDetails((prevDetails) => [...prevDetails, training]);
          //         }
          //       }
          //     })
          //     .catch((error) => {
          //       console.error(error);
          //     });
          // });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [localStorage.getItem("userId")]);


  console.log("postedTrainingDetails", postedTrainingDetails);
  console.log("activeTrainingDetails", activeTrainingDetails);
  console.log("cancelledTrainingDetails", cancelledTrainingDetails);
  console.log("completedTrainingDetails", completedTrainingDetails);

  const [expectedNewPaymentDate, setExpectedNewPaymentDate] = useState('');
  const [paymentNotReceivedModal, setPaymentNotReceivedModal] = useState(false);
  const [trainerWithStatus6Modal, setTrainerWithStatus6Modal] = useState(false);
  const [trainerWithStatus7Modal, setTrainerWithStatus7Modal] = useState(false);
  const [paymentExceededModal, setPaymentExceededModal] = useState(false);
  const [waitingTrainingConfirmation, setWaitingTrainingConfirmation] = useState(false);
  const [trainerStatus12, setTrainerStatus12] = useState([]);
  const [trainerStatus20, setTrainerStatus20] = useState([]);
  const [trainerExceededPayment, setTrainerExceededPayment] = useState([]);
  const [trainerWithStatus6, setTrainerWithStatus6] = useState([]);
  const [trainerWithStatus7, setTrainerWithStatus7] = useState([]);
  const [trainerWithStatus3, setTrainerWithStatus3] = useState([]);
  const [trainerStatus3, setTrainerStatus3] = useState(false);
  const [trainerStatus1, setTrainerStatus1] = useState(false);
  const [trainerWithStatus1, setTrainerWithStatus1] = useState([]);
  const [trainerWithStatus4, setTrainerWithStatus4] = useState([]);
  const [trainerWithStatus9, setTrainerWithStatus9] = useState([]);
  const [trainerWithStatus9Modal, setTrainerWithStatus9Modal] = useState(false);
  const [trainerStatus4, setTrainerStatus4] = useState(false);

  useEffect(() => {
    const fetchData = async (trainingID) => {
      try {
        const [activeTrainerListResp, singleTrainingDataResp] = await Promise.all([
          fetch(`${process.env.REACT_APP_API_URL}/api/active-trainer-list/${trainingID}/`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
          }).then((resp) => resp.json()),
          fetch(`${process.env.REACT_APP_API_URL}/api/single-training-more-details/${trainingID}/`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
          }).then((resp) => resp.json()),
        ]);

        const { detail: activeTrainerListDetail } = activeTrainerListResp;
        const { detail: singleTrainingDataDetail } = singleTrainingDataResp;

        if (activeTrainerListDetail && singleTrainingDataDetail) {
          return;
        }

        setTrainingDetails(singleTrainingDataResp);

        console.log("singleTrainingDataResp", singleTrainingDataResp);

        const trainerWithStatus12 = activeTrainerListResp.find(
          (trainer) =>
            parseInt(trainer.apply_training.applyTrainingStatus) === 12 &&
            [10, 17, 18].includes(parseInt(trainer.apply_training.previousStatus)) &&
            (!singleTrainingDataResp.expectedPaymentDate1 ||
              !singleTrainingDataResp.expectedPaymentDate2 ||
              !singleTrainingDataResp.expectedPaymentDate3)
        );

        const trainerMustSubmitProof = activeTrainerListResp.find(
          (trainer) =>
            parseInt(trainer.apply_training.applyTrainingStatus) === 10 &&
            parseInt(trainer.apply_training.previousStatus) === 19 &&
            singleTrainingDataResp.expectedPaymentDate1 &&
            singleTrainingDataResp.expectedPaymentDate2 &&
            singleTrainingDataResp.expectedPaymentDate3
        );

        const trainerNotReceivedPayment = activeTrainerListResp.find(
          (trainer) =>
            parseInt(trainer.apply_training.applyTrainingStatus) === 12 &&
            parseInt(trainer.apply_training.previousStatus) === 20 &&
            singleTrainingDataResp.expectedPaymentDate1 &&
            singleTrainingDataResp.expectedPaymentDate2 &&
            singleTrainingDataResp.expectedPaymentDate3
        );

        const trainerExceededLastPaymentDate = activeTrainerListResp.find((trainer) =>
          parseInt(trainer.apply_training.applyTrainingStatus) === 12 &&
          parseInt(trainer.apply_training.previousStatus) === 19
        );

        const trainerWithStatus20 = activeTrainerListResp.find((trainer) =>
          parseInt(trainer.apply_training.applyTrainingStatus) === 20
        );

        const todayDate = new Date().toISOString().split('T')[0];

        const trainerWithStatus6 = activeTrainerListResp.find((trainer) =>
          parseInt(trainer.apply_training.applyTrainingStatus) === 6 &&
          new Date(todayDate) >= new Date(singleTrainingDataResp.trainingStartDate)
        );

        const trainerWithStatus7 = activeTrainerListResp.find((trainer) =>
          parseInt(trainer.apply_training.applyTrainingStatus) === 7 &&
          new Date(todayDate) > new Date(singleTrainingDataResp.trainingEndDate)
        );

        const trainerWithStatus9 = activeTrainerListResp.find(
          (trainer) =>
            parseInt(trainer.apply_training.applyTrainingStatus) === 9 &&
            parseInt(trainer.apply_training.previousStatus) === 8 &&
            new Date(todayDate) > new Date(singleTrainingDataResp.expectedPaymentDate)
        );

        const trainerWithStatus17 = activeTrainerListResp.find(
          (trainer) =>
            parseInt(trainer.apply_training.applyTrainingStatus) === 17 &&
            parseInt(trainer.apply_training.previousStatus) === 12 &&
            new Date(todayDate) > new Date(singleTrainingDataResp.expectedPaymentDate1)
        );

        const trainerWithStatus18 = activeTrainerListResp.find(
          (trainer) =>
            parseInt(trainer.apply_training.applyTrainingStatus) === 18 &&
            parseInt(trainer.apply_training.previousStatus) === 12 &&
            new Date(todayDate) > new Date(singleTrainingDataResp.expectedPaymentDate2)
        );

        const trainerWithStatus19 = activeTrainerListResp.find(
          (trainer) =>
            parseInt(trainer.apply_training.applyTrainingStatus) === 19 &&
            parseInt(trainer.apply_training.previousStatus) === 12 &&
            new Date(todayDate) > new Date(singleTrainingDataResp.expectedPaymentDate3)
        );

        const trainerWithStatus1 = activeTrainerListResp.find((trainer) =>
          parseInt(trainer.apply_training.applyTrainingStatus) === 1);

        const trainerWithStatus3 = activeTrainerListResp.find((trainer) =>
          parseInt(trainer.apply_training.applyTrainingStatus) === 3);

        const trainerWithStatus4 = activeTrainerListResp.find((trainer) =>
          parseInt(trainer.apply_training.applyTrainingStatus) === 4);

        if (trainerWithStatus1) {
          setTrainerStatus1(true);
          setTrainerWithStatus1((prev) => [...prev, trainerWithStatus1]);
        }

        if (trainerWithStatus3) {
          setTrainerStatus3(true);
          setTrainerWithStatus3((prev) => [...prev, trainerWithStatus3]);
        }

        if (trainerWithStatus4) {
          setTrainerStatus4(true);
          setTrainerWithStatus4((prev) => [...prev, trainerWithStatus4]);
        }

        if (trainerWithStatus9) {
          console.log("trainerWithStatus9", trainerWithStatus9);
          setTrainerWithStatus9Modal(true);
          setTrainerWithStatus9((prev) => [...prev, trainerWithStatus9]);
        }

        if (trainerWithStatus17) {
          console.log("trainerWithStatus17", trainerWithStatus17);
          setTrainerWithStatus9Modal(true);
          setTrainerWithStatus9((prev) => [...prev, trainerWithStatus17]);
        }

        if (trainerWithStatus18) {
          console.log("trainerWithStatus18", trainerWithStatus18);
          setTrainerWithStatus9Modal(true);
          setTrainerWithStatus9((prev) => [...prev, trainerWithStatus18]);
        }

        if (trainerWithStatus19) {
          console.log("trainerWithStatus19", trainerWithStatus19);
          setTrainerWithStatus9Modal(true);
          setTrainerWithStatus9((prev) => [...prev, trainerWithStatus19]);
        }

        if (trainerWithStatus12) {
          setPaymentNotReceivedModal(true);
          setTrainerStatus12((prev) => [...prev, trainerWithStatus12]);
        }

        if (trainerMustSubmitProof) {
          setPaymentExceededModal(true);
          setTrainerExceededPayment((prev) => [...prev, trainerMustSubmitProof]);
        }

        if (trainerNotReceivedPayment) {
          console.log("trainerNotReceivedPayment", trainerNotReceivedPayment);
          setPaymentExceededModal(true);
          setTrainerExceededPayment((prev) => [...prev, trainerNotReceivedPayment]);
        }

        if (trainerExceededLastPaymentDate) {
          console.log("trainerExceededLastPaymentDate", trainerExceededLastPaymentDate);
          setPaymentExceededModal(true);
          setTrainerExceededPayment((prev) => [...prev, trainerExceededLastPaymentDate]);
        }

        if (trainerWithStatus20) {
          console.log("trainerWithStatus20", trainerWithStatus20);
          setWaitingTrainingConfirmation(true);
          setTrainerStatus20((prev) => [...prev, trainerWithStatus20]);
        }

        if (trainerWithStatus6) {
          console.log("trainerWithStatus6", trainerWithStatus6);
          setTrainerWithStatus6Modal(true);
          setTrainerWithStatus6(trainerWithStatus6);
        }

        if (trainerWithStatus7) {
          console.log("trainerWithStatus7", trainerWithStatus7);
          setTrainerWithStatus7Modal(true);
          setTrainerWithStatus7(trainerWithStatus7);
        }

      } catch (error) {
        console.error("Error fetching data:", error.message);
      }
    };

    activeTrainingDetails.forEach((training) => {
      fetchData(training.id);
    });
  }, [activeTrainingDetails]);

  console.log("trainerStatus12", trainerStatus12);
  console.log("trainerExceededPayment", trainerExceededPayment);
  console.log("paymentNotReceivedModal", paymentNotReceivedModal);
  console.log("paymentExceededModal", paymentExceededModal);
  console.log("waitingTrainingConfirmation", waitingTrainingConfirmation);

  console.log("trainerStatus3", trainerStatus3);
  console.log("trainerWithStatus3", trainerWithStatus3);

  console.log("trainerStatus4", trainerStatus4);
  console.log("trainerWithStatus4", trainerWithStatus4);

  console.log("trainerWithStatus9Modal", trainerWithStatus9Modal);
  console.log("trainerWithStatus9", trainerWithStatus9);


  useEffect(() => {
    let id = localStorage.getItem("userId");
    fetch(`${process.env.REACT_APP_API_URL}/api/pending-action-company-get/${id}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data) {
          setPendingAction(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [localStorage.getItem("userId")])

  console.log("pendingAction", pendingAction);

  const today = new Date().toISOString().split('T')[0];

  const maxDate = new Date();
  maxDate.setDate(maxDate.getDate() + 30);
  const maxDateString = maxDate.toISOString().split('T')[0];

  const handleExpectedNewPaymentDateChange = (event) => {
    setExpectedNewPaymentDate(event.target.value);
  };

  const onStartTrainingClick = (trainer) => {
    setLoading(true);
    setTrainerWithStatus6Modal(false);
    console.log("111111111111111111", trainer);

    let applyTraining = trainer.apply_training;
    const data = {
      applyTrainingStatus: "7",
      previousStatus: "6",
      appliedTrainerID: applyTraining.appliedTrainerID,
      trainingCompanyUserID: applyTraining.trainingCompanyUserID,
      selectedTrainingID: applyTraining.selectedTrainingID,
      selectedTrainingName: applyTraining.selectedTrainingName,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setTrainerWithStatus6Modal(false);
          setSubmitStartTrainingCompleted(true);
          setLoading(false);
        } else {
          setTrainerWithStatus6Modal(false);
          setSubmitStartTrainingCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  const onModifyTrainingClick = (trainer) => {
    console.log("@@@@@@@@@@@@@@", trainer.apply_training.selectedTrainingID);
    const id = trainer.apply_training.selectedTrainingID;
    navigate(`/app/activetrainingmoredetails/${id}/`);
  };

  const onPaymentCompletedClick = (trainer) => {
    setLoading(true);
    console.log("111111111111111111", trainer);
    let applyTraining = trainer.apply_training;
    const data = {
      applyTrainingStatus: "10",
      previousStatus: applyTraining.applyTrainingStatus,
      appliedTrainerID: applyTraining.appliedTrainerID,
      trainingCompanyUserID: applyTraining.trainingCompanyUserID,
      selectedTrainingID: applyTraining.selectedTrainingID,
      selectedTrainingName: applyTraining.selectedTrainingName,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setTrainerWithStatus9Modal(false);
          setSubmitPaymentCompleted(true);
          setLoading(false);
        } else {
          setSubmitPaymentCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  const onTrainingCompletedClick = (trainer) => {
    setLoading(true);
    setTrainerWithStatus7Modal(false);
    console.log("111111111111111111", trainer);
    let applyTraining = trainer.apply_training;
    const data = {
      applyTrainingStatus: "8",
      previousStatus: "7",
      appliedTrainerID: applyTraining.appliedTrainerID,
      trainingCompanyUserID: applyTraining.trainingCompanyUserID,
      selectedTrainingID: applyTraining.selectedTrainingID,
      selectedTrainingName: applyTraining.selectedTrainingName,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setFeedbackStatusAvailable(true);
          setLoading(false);
        } else {
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };


  const onSubmitNewPaymentClick = (trainer) => {
    setLoading(true);
    setPaymentNotReceivedModal(false);
    console.log("trainer", trainer);
    fetch(`${process.env.REACT_APP_API_URL}/api/single-training-more-details/${trainer[0].apply_training.selectedTrainingID}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setTrainingDetails(data);
        }
      })
      .then(() => {
        let targetPaymentDateProperty;
        let applyTrainingStatus;

        if (trainingDetails.expectedPaymentDate && !trainingDetails.expectedPaymentDate1) {
          targetPaymentDateProperty = "expectedPaymentDate1";
          applyTrainingStatus = "17";
        } else if (trainingDetails.expectedPaymentDate && trainingDetails.expectedPaymentDate1 && !trainingDetails.expectedPaymentDate2) {
          targetPaymentDateProperty = "expectedPaymentDate2";
          applyTrainingStatus = "18";
        } else if (trainingDetails.expectedPaymentDate && trainingDetails.expectedPaymentDate1 && trainingDetails.expectedPaymentDate2 && !trainingDetails.expectedPaymentDate3) {
          targetPaymentDateProperty = "expectedPaymentDate3";
          applyTrainingStatus = "19";
        } else {
          console.error("Invalid conditions for updating payment date");
          return;
        }

        const paymentUpdateData = {
          [targetPaymentDateProperty]: expectedNewPaymentDate,
        };

        console.log(JSON.stringify(paymentUpdateData));

        Promise.all([
          fetch(`${process.env.REACT_APP_API_URL}/api/training-update-date/${trainer[0].apply_training.selectedTrainingID}/`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(paymentUpdateData),
          }),
        ])
          .then((responses) => {
            const [updateDateResponse] = responses;
            if (updateDateResponse.ok) {
              console.log("Update date success");
              setPaymentNotReceivedModal(false);

              const trainerStatusData = {
                applyTrainingStatus: applyTrainingStatus,
                previousStatus: trainer[0].apply_training.applyTrainingStatus,
                appliedTrainerID: trainer[0].apply_training.appliedTrainerID,
                trainingCompanyUserID: trainer[0].apply_training.trainingCompanyUserID,
                selectedTrainingID: trainer[0].apply_training.selectedTrainingID,
                selectedTrainingName: trainer[0].apply_training.selectedTrainingName,
              };

              return fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(trainerStatusData),
              });
            } else {
              setPaymentNotReceivedModal(true);
              setSubmitNewPaymentDateCompleted(false);
              throw new Error("Update date failed. Something went wrong");
            }
          })
          .then((trainerStatusResponse) => {
            if (trainerStatusResponse.ok) {
              console.log("Trainer status update success");
              setSubmitNewPaymentDateCompleted(true);
              setLoading(false);
            } else {
              console.error("Trainer status update failed. Something went wrong");
              setSubmitNewPaymentDateCompleted(false);
            }
          })
          .catch((error) => {
            console.log("Error:", error.message);
          });
      })
      .catch((error) => {
        console.error("Error fetching additional details:", error);
      });
  };

  console.log("postedTrainingDetails", postedTrainingDetails);
  console.log("appliedTrainingDetails", appliedTrainingDetails);

  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    let display = "card";
    fetch(`${process.env.REACT_APP_API_URL}/api/dashboard-company-recruit/${id}/${display}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setTrainerRecruitDetails(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [userId]);
  console.log("trainerRecruitDetails", trainerRecruitDetails);

  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    let display = "card";
    fetch(`${process.env.REACT_APP_API_URL}/api/company-skills-equvalent/${id}/${display}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          // setRecommendedSkillsDetails(data);
          setSkillErrorMessage(data.message);
          if (!data.message) {
            setRecommendedSkillsDetails(data);
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [userId]);
  console.log("recommendedSkillsDetails", recommendedSkillsDetails);

  useEffect(() => {
    setErrorMsg("");
  }, [submitOTPCompleted, otpValidated])

  const onApplyClick = (training) => {

  };

  const navigate = useNavigate();

  const onActiveTrainingMoreDetails = (training) => {
    console.log("training", training.id);
    navigate(`/app/activetrainingmoredetails/${training.id}/`);
  };

  const onSkillsMoreDetails = (trainer) => {
    console.log("training", trainer.trainer_profile_id);
    navigate(`/app/recommendedtrainermoredetails/${trainer.trainer_profile_id}/`);
  };

  const onRecruitedTrainerMoreDetails = (trainer) => {
    console.log("training", trainer.trainerRecruitID);
    navigate(`/app/recruitedtrainermoredetails/${trainer.trainerRecruitID}/`);
  };

  function getStatus(trainingCompanyRecruitStatus, trainerAcceptStatus, trainingCompanyAgreeStatus) {
    if (trainingCompanyRecruitStatus === "Yes" && trainerAcceptStatus === null && trainingCompanyAgreeStatus === null) {
      return "Awaiting For Trainer's response";
    } else if (trainingCompanyRecruitStatus === "Yes" && trainerAcceptStatus === "Accept" && trainingCompanyAgreeStatus === null) {
      return "Trainer - Accepted. Awaiting for your response";
    } else if (trainingCompanyRecruitStatus === "Yes" && trainerAcceptStatus === "Decline" && trainingCompanyAgreeStatus === null) {
      return "Trainer has Declined your request";
    } else if (trainingCompanyRecruitStatus === "Yes" && trainerAcceptStatus === "Accept" && trainingCompanyAgreeStatus === "Accept") {
      return "Mutually agreed for the training";
    } else if (trainingCompanyRecruitStatus === "Yes" && trainerAcceptStatus === "Accept" && trainingCompanyAgreeStatus === "Decline") {
      return "Trainer has been rejected";
    } else {
      return "Status not available";
    }
  }

  function getStatusMessage(training) {
    console.log("training.status", training.status);
    if (training.status === "Active") {
      return "Training is Active";
    } else if (training.status === "6") {
      return "Training Scheduling confirmed with trainer";
    } else if (training.status === "7") {
      return "Training has been Started";
    } else if (training.status === "8") {
      return "Training has been Completed";
    } else if (training.status === "9") {
      return "Invoice sent to the Training Partner";
    } else if (training.status === "10") {
      return "Payment Completed";
    } else if (training.status === "11") {
      return "Training Completed";
    } else if (training.status === "12") {
      return "Payment Not Received by the Trainer";
    } else if (training.status === "17") {
      return "1st New Payment Date has been submitted";
    } else if (training.status === "18") {
      return "2nd New Payment Date has been submitted";
    } else if (training.status === "19") {
      return "Final New Payment Date has been submitted";
    } else if (training.status === "21") {
      return "Training has been Cancelled";
    } else {
      return "Unknown Status";
    }
  }


  const onConnectClick = (trainerList) => {
    setLoading(true);
    setMaxRecruitCount(false);
    let id = localStorage.getItem("userId");
    console.log("trainerList", trainerList)
    setSelectedTrainer(trainerList);
    // setSelectedTrainerId(trainer.id);
    const data = {
      trainingCompanyID: id,
      trainerID: trainerList.trainer_profile_id,
      trainingCompanyRecruitStatus: "Yes",
      premiumStatus:trainingCompanyProfileDetails.premiumStatus,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/company-recruit-trainer/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          setRecruitSubmitCompleted(false);
          throw new Error("Response not Submitted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("Response from backend:", data.message);
        if (data.message === "Remainder reached maximum for the day") {
          setResponseRecruitFromDB(data.message);
          setMaxRecruitCount(true);
        } else if (data.message === "We have sent you a link to the Trainer to accept your request") {
          setResponseRecruitFromDB(data.message);
          setRecruitSubmitCompleted(true);
        } else {
          setResponseRecruitFromDB(data.message);
          setRecruitSubmitCompleted(false);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };
  console.log("selectedTrainer", selectedTrainer);

  const DialogProfileRecruitConnectClose = () => {
    setRecruitSubmitCompleted(false);
    window.location.href = "/app/trainingcompanydashboard";
  };

  const onAgreeClick = (trainer) => {
    console.log("111111111111111111", trainer);
    let id = localStorage.getItem("userId");
    const data = {
      trainingCompanyAgreeStatus: "Accept",
      trainerID: trainer.user_id,
      trainingCompanyID: id,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/accept-company-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setSubmitAcceptCompleted(true);
        } else {
          setSubmitAcceptCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  const DialogProfileAcceptClose = () => {
    setSubmitAcceptCompleted(false);
    window.location.href = "/app/trainingcompanydashboard";
  };

  const DialogProfileStartTrainingClose = () => {
    setSubmitStartTrainingCompleted(false);
    window.location.href = "/app/trainingcompanydashboard";
  };

  const DialogProfileFeedbackClose = () => {
    setSubmitFeedbackCompleted(false);
    window.location.href = `/app/trainingcompanydashboard`;
  };

  const DialogProfilePaymentCompletedClose = () => {
    setSubmitPaymentCompleted(false);
    window.location.href = `/app/trainingcompanydashboard`;
  };

  const DialogProfilePaymentConfirmationClose = () => {
    setSubmitPaymentConfirmationCompleted(false);
    window.location.href = `/app/trainingcompanydashboard`;
  };

  const DialogProfileNewPaymentDateClose = () => {
    setSubmitNewPaymentDateCompleted(false);
    window.location.href = `/app/trainingcompanydashboard`;
  };

  const onRemainderClick = (trainer) => {
    setLoading(true);
    setMaxRemainderCount(false);
    console.log("recruitRemainder", trainer.trainerRecruitID);
    const data = {
      id: trainer.trainerRecruitID,
      premiumStatus:trainingCompanyProfileDetails.premiumStatus,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/company-recruit-trainer-reminder/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          setSubmitRemainderCompleted(false);
          throw new Error("Profile is not created. Something went wrong");
          setLoading(false);
        }
      })
      .then((data) => {
        console.log("Response from backend:", data.message);
        if (data.message === "Remainder reached maximum for the day") {
          setResponseFromDB(data.message);
          setMaxRemainderCount(true);
          setLoading(false);
        } else if (data.message === "We have sent you a link to the Trainer to accept your request") {
          setResponseFromDB(data.message);
          setSubmitRemainderCompleted(true);
          setLoading(false);
        } else {
          setResponseFromDB(data.message);
          setSubmitRemainderCompleted(false);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("Error:", error.message);
      });
  };

  console.log("responseFromDB", responseFromDB);

  console.log("remaindecount", maxRemainderCount);

  const DialogProfileClose = () => {
    setSubmitRemainderCompleted(false);
  };

  const paymentProofFileInputRef = useRef(null);
  const [fileUploaded, setFileUploaded] = useState(false);

  const handleUploadClick = () => {
    paymentProofFileInputRef.current.click();

  };

  const [paymentProof, setPaymentProof] = useState([]);
  const [s3BucketURL, setS3BucketURL] = useState(null);

  AWS.config.update({
    accessKeyId: process.env.REACT_APP_S3_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_S3_AWS_SECRET_ACCESS_KEY,
    region: process.env.REACT_APP_S3_REGION,
  });

  useEffect(() => {
    let userName = localStorage.getItem("user");
    let id = localStorage.getItem("userId");
    let bucketURL = `trainingcompanyhub/${id}_${userName}/payment-proof/`;
    setS3BucketURL(bucketURL);
  }, [localStorage.getItem("user")])

  const [error, setError] = useState(null);

  const handlePaymentProofUploadChange = (event) => {
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      const fileExtension = selectedFile.name.split('.').pop();
      const allowedFormats = ['jpeg', 'jpg', 'png', 'pdf'];

      if (!allowedFormats.includes(fileExtension.toLowerCase())) {
        setError("Please check the file format.");
        return;
      }

      if (selectedFile.size > 300 * 1024) {
        setError("File size should be maximum 300kb.");
        return;
      }
      setError(null);

      const renamedFile = new File([selectedFile], `${trainerExceededPayment[0].apply_training.selectedTrainingName}_paymentProof.${fileExtension}`, { type: selectedFile.type });

      setPaymentProof(renamedFile);
      const formData = new FormData();
      formData.append('files', renamedFile);

      fetch(`${process.env.REACT_APP_API_URL}/api/upload/${s3BucketURL}`, {
        method: 'POST',
        body: formData,
      })
        .then(response => response.json())
        .then(data => {
          console.log(data);
        })
        .catch(error => {
          console.error('Error uploading file:', error);
        });
    }
    setFileUploaded(true);
  };


  console.log("paymentProof", paymentProof);

  const onNewPaymentCompletedClick = (trainer) => {
    console.log("########", trainer);
    let applyTraining = trainer[0].apply_training;
    const data = {
      applyTrainingStatus: "10",
      previousStatus: applyTraining.applyTrainingStatus,
      appliedTrainerID: applyTraining.appliedTrainerID,
      trainingCompanyUserID: applyTraining.trainingCompanyUserID,
      selectedTrainingID: applyTraining.selectedTrainingID,
      selectedTrainingName: applyTraining.selectedTrainingName,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setPaymentExceededModal(false);
          setPaymentNotReceivedModal(false);
          setSubmitPaymentConfirmationCompleted(true);
        } else {
          setSubmitPaymentConfirmationCompleted(false);
          setPaymentExceededModal(true);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  const onFinalPaymentCompletedClick = (trainer) => {
    console.log("########", trainer);
    let applyTraining = trainer.apply_training;
    const data = {
      applyTrainingStatus: "20",
      previousStatus: applyTraining.applyTrainingStatus,
      appliedTrainerID: applyTraining.appliedTrainerID,
      trainingCompanyUserID: applyTraining.trainingCompanyUserID,
      selectedTrainingID: applyTraining.selectedTrainingID,
      selectedTrainingName: applyTraining.selectedTrainingName,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          // setSubmitAcceptCompleted(true);
          setPaymentExceededModal(false);
          setWaitingTrainingConfirmation(true);
        } else {
          // setSubmitAcceptCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  // const renderTrainingCards = () => {
  //   const startIndex = postedCurrentSlide * 2;
  //   const endIndex = startIndex + 2;
  //   const currentTrainings = postedTrainingDetails.slice(startIndex, endIndex);
  //   const remainingTrainingsCount = postedTrainingDetails.length - endIndex;

  //   return currentTrainings.map((training, index) => (
  //     <div key={index} style={{ flex: '0 0 auto', marginRight: '20px', marginTop: '-10px', width: '49%' }}>
  //       <Grid item xs={12} key={training.id} className="gridItemTC">
  //         <div className="gridContent">
  //           <div className="trainingInfo">
  //             <MKTypography variant="subtitle1" className="trainingName"><strong>{training.trainingName}</strong></MKTypography>
  //             <MKTypography style={{ fontSize: 'medium' }}>
  //               <span style={{ display: 'flex', alignItems: 'center' }}>
  //                 <img src={Logo} alt="Skills Logo" style={{ whiteSpace: 'nowrap', marginRight: '5px', width: '20px', height: '20px' }} /> {training.technology}
  //               </span>
  //             </MKTypography>
  //             <MKTypography style={{ fontSize: 'medium' }}>
  //               <span style={{ display: 'flex', alignItems: 'center' }}>
  //                 <img src={CompanyIcon} alt="Company Icon" style={{ marginRight: '5px', width: '20px', height: '20px' }} />{training.trainingCompanyName}
  //               </span>
  //             </MKTypography>
  //             <MKTypography style={{ fontSize: 'medium' }}>
  //               <span style={{ display: 'flex', alignItems: 'center' }}>
  //                 <LocationOn style={{ marginRight: '5px' }} /> {training.trainingMode}
  //                 {training.trainingMode === 'Classroom' ? ` | ${training.trainingLocations}` : ''}
  //               </span>
  //             </MKTypography>
  //             <MKTypography style={{ fontSize: 'medium' }}>
  //               <span style={{ display: 'flex', alignItems: 'center' }}>
  //                 {training.currency}&nbsp;{training.totalTrainingBudget} |&nbsp;<img src={Expectation} alt="Expectation Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training.trainingExpectation}
  //               </span>
  //             </MKTypography>
  //             <MKTypography style={{ fontSize: 'medium' }}>
  //               <span style={{ display: 'flex', alignItems: 'center' }}>
  //                 <CalendarMonthIcon style={{ marginRight: '5px' }} /> {training.expectedStartDate}
  //               </span>
  //             </MKTypography>
  //             <MKTypography style={{ fontSize: 'medium' }}>
  //               <span style={{ display: 'flex', alignItems: 'center' }}>
  //                 <strong> Status: {getStatusMessage(training)} </strong>
  //               </span>
  //             </MKTypography>
  //           </div>
  //           <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-40px' }}>
  //             <MKButton variant="gradient" color="info" size="small" onClick={() => onActiveTrainingMoreDetails(training)} style={{ padding: '5px 10px' }}>Details</MKButton>
  //           </div>
  //         </div>
  //       </Grid>
  //     </div>
  //   )).concat(
  //     remainingTrainingsCount > 0 && (
  //       <div key="see-more-card" style={{ flex: '0 0 auto', marginRight: '20px', marginTop: '-10px', width: '49%' }}>
  //         <Grid item xs={12} className="gridItemTC">
  //           <div className="gridContent">
  //             <div className="trainingInfo">
  //               <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
  //                 &nbsp;
  //               </MKTypography>
  //               <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
  //                 &nbsp;
  //               </MKTypography>
  //               <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
  //                 &nbsp;
  //               </MKTypography>
  //               <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
  //                 <a href="/app/postedtrainingseemore" style={{ color: 'blue', textDecoration: 'underline' }}>
  //                   See More
  //                 </a>
  //               </MKTypography>
  //               <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
  //                 &nbsp;
  //               </MKTypography>
  //               <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
  //                 &nbsp;
  //               </MKTypography>
  //             </div>
  //           </div>
  //         </Grid>
  //       </div>
  //     )
  //   );
  // };


  return (
    <>
      <LoadingOverlay loading={loading}>
        <IdleTimeOutHandler />
        <DefaultNavbar
          routes={trainingCompanyProfileCreate ? routes : editRoutes}
          sticky
        />
        <Card
          sx={{
            p: 2,
            mx: { xs: 2, lg: 3 },
            mt: -8,
            mb: 4,
            // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
            backdropFilter: "saturate(200%) blur(30px)",
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        >
          <Container>
            <Grid container>
              <Grid item xs={12} style={{ marginTop: "150px" }}>
                <div>
                  <Dialog
                    open={submitRemainderCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Notification !
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Remainder mail has been sent successfully !
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <MKButton key="ok-button1" onClick={() => { setSubmitRemainderCompleted(false); DialogProfileClose(); }} variant="gradient" color="info" size="small" autoFocus>
                        OK
                      </MKButton>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={submitAcceptCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Notification !
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Your response has been sent to the trainer.
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <MKButton key="ok-button2" onClick={() => { setSubmitAcceptCompleted(false); DialogProfileAcceptClose(); }} variant="gradient" color="info" size="small" autoFocus>
                        OK
                      </MKButton>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={submitStartTrainingCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Notification !
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        The trainer has been notified about the start of the training
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <MKButton key="ok-button3" onClick={() => { setSubmitStartTrainingCompleted(false); DialogProfileStartTrainingClose(); }} variant="gradient" color="info" size="small" autoFocus>
                        OK
                      </MKButton>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={submitFeedbackCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Thank you!
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Your Feedback has been submitted to the trainer.
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <MKButton key="ok-button4" onClick={() => { setSubmitFeedbackCompleted(false); DialogProfileFeedbackClose(); }} variant="gradient" color="info" size="small" autoFocus>
                        OK
                      </MKButton>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={submitPaymentConfirmationCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Success!
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Your payment confirmation has been submitted to the trainer.
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <MKButton key="ok-button5" onClick={() => { setSubmitPaymentConfirmationCompleted(false); DialogProfilePaymentConfirmationClose(); }} variant="gradient" color="info" size="small" autoFocus>
                        OK
                      </MKButton>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={submitPaymentCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Success!
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Your payment confirmation has been submitted to the trainer.
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <MKButton key="ok-button6" onClick={() => { setSubmitPaymentCompleted(false); DialogProfilePaymentCompletedClose(); }} variant="gradient" color="info" size="small" autoFocus>
                        OK
                      </MKButton>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={submitNewPaymentDateCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Success!
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        New Payment date has been submitted to the trainer.
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <MKButton key="ok-button7" onClick={() => { setSubmitNewPaymentDateCompleted(false); DialogProfileNewPaymentDateClose(); }} variant="gradient" color="info" size="small" autoFocus>
                        OK
                      </MKButton>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={recruitSubmitCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Notification !
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Your response has been sent to the trainer.
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <MKButton key="ok-button8" onClick={() => { setRecruitSubmitCompleted(false); DialogProfileRecruitConnectClose(); }} variant="gradient" color="info" size="small" autoFocus>
                        OK
                      </MKButton>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    style={{ height: "100%" }}
                    open={submitCompleted}
                    scroll={scroll}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    // fullWidth
                    maxWidth="md"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Terms and Condition !
                    </DialogTitle>
                    <DialogContent dividers={scroll === "paper"}>
                      <TrainingCompanyTermsAndCondition />
                      <div style={{ marginTop: '10px' }}>
                        <input
                          type="checkbox"
                          id="agreeCheckbox"
                          checked={agreed}
                          onChange={() => setAgreed(!agreed)}
                        />
                        <label htmlFor="agreeCheckbox">
                          <strong>&nbsp;&nbsp;I agree</strong>
                        </label>
                      </div>
                    </DialogContent>
                    <DialogActions>
                      <MKButton
                        onClick={() => {
                          if (agreed) {
                            OnOkClick();
                          } else {
                          }
                        }}
                        color="info"
                        variant="gradient"
                        size="small"
                        autoFocus
                      >
                        OK
                      </MKButton>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={submitMobileCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    onClose={handleDialogClose}
                  >
                    <DialogTitle id="alert-dialog-title">Attention!</DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Your journey with us is just a text away. Please verify your mobile number!
                      </DialogContentText>
                      <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                        <div>
                          <FormControl variant="outlined" style={{ width: '250px' }}>
                            <InputLabel id="Select Country">Select Country *</InputLabel>
                            <Select
                              labelId="Select Country "
                              label="Select Country"
                              // fullWidth
                              onChange={handleCountryChange}
                              value={selectedCountry}
                              style={{ minHeight: '44px' }}
                            >
                              {CountryList.getAll().map((country, index) => (
                                <MenuItem key={`${country.name}-${index}`} value={country.name}>
                                  {country.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                        <div>
                          <TextField
                            label="Code *"
                            name="Code"
                            value={countryCode}
                            InputProps={{
                              readOnly: true,
                            }}
                            style={{ width: '250px', minHeight: '44px' }}
                          // fullWidth
                          />
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                        <div>
                          <TextField
                            label="Enter Mobile Number *"
                            variant="outlined"
                            style={{ width: "520px", borderColor: mobileNumberError ? 'red' : undefined }}
                            onChange={(e) => {
                              setMobileNumber(e.target.value);
                              handleMobileNumberChange(e, setMobileNumberError);
                            }}
                            error={!mobileNumberError}
                            value={mobileNumber}
                          // fullWidth
                          />
                        </div>
                      </div>
                      <div>
                        {errorMsg ? (
                          <InputLabel style={{ marginTop: "10px", color: "red", padding: "5px" }}>{errorMsg}</InputLabel>
                        ) : (
                          ""
                        )}
                      </div>
                    </DialogContent>
                    <DialogActions>
                      <MKButton style={{ marginTop: "-20px" }}
                        onClick={handleMobNumSubmit} variant="gradient" color="info"
                        disabled={!selectedCountry || !mobileNumber || !mobileNumberError}
                        autoFocus size='small'>
                        Submit
                      </MKButton>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={submitOTPCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    onClose={handleOTPDialogClose}
                  >
                    <DialogTitle id="alert-dialog-title">Attention Required!</DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Validate your identity by entering the OTP received for verification.
                      </DialogContentText>
                      <div style={{ display: 'flex', marginTop: '10px' }}>
                        <div>
                          <TextField
                            label="Enter the OTP"
                            variant="outlined"
                            style={{ width: "520px" }}
                            onChange={(e) => setOtpValue(e.target.value)}
                            error={!mobileNumberError}
                            value={otpValue}
                          // fullWidth
                          />
                        </div>
                      </div>
                    </DialogContent>
                    {!otpValidated ? (
                      <DialogContent style={{ display: 'flex', justifyContent: 'right', marginTop: "-20px" }}>
                        <MKButton onClick={handleResendOTP} color="info" variant="gradient" color="info" size="small" disabled={resendDisabled}>
                          Resend OTP?
                        </MKButton>
                        <span style={{ marginLeft: '10px' }}>{formatTime(timer)}</span>
                      </DialogContent>
                    ) : (
                      ""
                    )}
                    {otpValidated ? (
                      <DialogContent>
                        <div>
                          <InputLabel style={{ marginBottom: "10px" }}>Great news! Your mobile number has been successfully validated.</InputLabel>
                          <InputLabel style={{ marginBottom: "10px" }}>You're all set to proceed!</InputLabel>
                        </div>
                      </DialogContent>
                    ) : (
                      ""
                    )}
                    <div>
                      {errorMsg && !otpValidated ? (
                        <InputLabel style={{ marginTop: "-40px", color: "red", marginLeft: "20px" }}>{errorMsg}</InputLabel>
                      ) : (
                        ""
                      )}
                    </div>
                    {otpValidated ? (
                      <DialogActions>
                        <MKButton key="ok-button9" style={{ marginTop: "-30px" }} onClick={handleOTPDialogClose} color="info" variant="gradient" size="small" autoFocus>
                          OK
                        </MKButton>
                      </DialogActions>
                    ) : (
                      <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
                        <MKButton style={{ marginTop: "-30px" }} onClick={handleDialogClose} color="info" variant="gradient" size="small">
                          Cancel
                        </MKButton>
                        <MKButton style={{ marginTop: "-30px" }} onClick={handleValidateSubmit} color="info" variant="gradient" size="small" autoFocus>
                          Submit
                        </MKButton>
                      </DialogActions>
                    )}
                  </Dialog>
                </div>
                <div>
                  {maxRecruitCount ? (
                    <MKAlert color="error" dismissible >
                      You've reached the daily recruit limit !
                    </MKAlert>
                  ) : (
                    ""
                  )}
                </div>
                <div>
                  {maxRemainderCount ? (
                    <MKAlert color="error" dismissible >
                      You've reached the daily remainder limit !
                    </MKAlert>
                  ) : (
                    ""
                  )}
                </div>
                <div>
                  {trainerStatus1 || trainerStatus3 || trainerStatus4 ? (
                    <MKAlert color="error" dismissible>
                      You have pending action to be completed. Please{' '}
                      <a
                        href="app/trainingcompanypendingaction/"
                        style={{ marginLeft: '5px', color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(`/app/trainingcompanypendingaction/`);
                        }}
                      >
                        click here
                      </a>{' '}
                      &nbsp;to see your pending actions.
                    </MKAlert>
                  ) : null}
                </div>
                {trainerWithStatus6Modal && (
                  <>
                    <Modal open={trainerWithStatus6Modal} onClose={() => { setTrainerWithStatus6Modal(false); }} sx={{ display: "grid", placeItems: "center" }}>
                      <MKBox
                        position="relative"
                        width="580px"
                        display="flex"
                        flexDirection="column"
                        borderRadius="xl"
                        bgColor="white"
                        shadow="xl"
                      >
                        <h2 style={{ display: 'flex', justifyContent: 'center', whiteSpace: 'nowrap', fontSize: 'large', marginTop: '10px' }}>
                          Today's the day!
                        </h2>
                        <MKTypography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                          {trainerWithStatus6 ? (
                            <>
                              <span>Your &nbsp;
                                <strong style={{ fontWeight: 'bold' }}>
                                  {trainerWithStatus6.apply_training.selectedTrainingName}
                                </strong>&nbsp;
                                training is set to begin.
                              </span>
                            </>
                          ) : (
                            "No training information available"
                          )}
                        </MKTypography>
                        <MKTypography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                          Click the 'Start Training' button to kick off the session.
                        </MKTypography>
                        <MKTypography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                          If you want to modify the training click on "Modify Training".
                        </MKTypography>
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px', marginBottom: '20px' }}>
                          <MKButton variant="gradient" color="info" size="small" onClick={() => onStartTrainingClick(trainerWithStatus6)} style={{ padding: '5px 10px', marginRight: '10px' }}>Start Training</MKButton>
                          <MKButton variant="gradient" color="info" size="small" onClick={() => onModifyTrainingClick(trainerWithStatus6)} style={{ padding: '5px 10px' }}>Modify training</MKButton>
                        </div>
                      </MKBox>
                    </Modal>
                  </>
                )}
                {trainerWithStatus7Modal && (
                  <>
                    <Modal open={trainerWithStatus7Modal} sx={{ display: "grid", placeItems: "center" }}>
                      <MKBox
                        position="relative"
                        width="580px"
                        display="flex"
                        flexDirection="column"
                        borderRadius="xl"
                        bgColor="white"
                        shadow="xl"
                      >
                        <h2 style={{ display: 'flex', justifyContent: 'center', whiteSpace: 'nowrap', fontSize: 'large', marginTop: '10px' }}>
                          Notification !
                        </h2>
                        <MKTypography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                          {trainerWithStatus7 ? (
                            <>
                              <span>The training &nbsp;
                                <strong style={{ fontWeight: 'bold' }}>
                                  {trainerWithStatus7.apply_training.selectedTrainingName}
                                </strong>&nbsp;
                                is getting completed.
                              </span>
                            </>
                          ) : (
                            "No training information available"
                          )}
                        </MKTypography>
                        <MKTypography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                          Please click the "Training Complete" button to complete the training.
                        </MKTypography>
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px', marginBottom: '10px' }}>
                          <MKButton variant="gradient" color="info" size="small" onClick={() => onTrainingCompletedClick(trainerWithStatus7)} style={{ padding: '5px 10px' }}>Training Completed</MKButton>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <MKTypography style={{ fontSize: 'medium', marginLeft: '20px', marginBottom: '10px' }}>
                            In case of any issues, please reach us at support@labasservice.com
                          </MKTypography>
                        </div>
                      </MKBox>
                    </Modal>
                  </>
                )}
                {trainerWithStatus9Modal && (
                  <>
                    <Modal open={trainerWithStatus9Modal} sx={{ display: "grid", placeItems: "center" }}>
                      <MKBox
                        position="relative"
                        width="580px"
                        display="flex"
                        flexDirection="column"
                        borderRadius="xl"
                        bgColor="white"
                        shadow="xl"
                      >
                        <h2 style={{ display: 'flex', justifyContent: 'center', whiteSpace: 'nowrap', fontSize: 'large', marginTop: '10px' }}>
                          Take the final step!
                        </h2>
                        <MKTypography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                          {trainerWithStatus9 ? (
                            <>
                              <span>Complete the Payment for the training &nbsp;
                                <strong style={{ fontWeight: 'bold' }}>
                                  {trainerWithStatus9[0].apply_training.selectedTrainingName}
                                </strong>&nbsp;
                              </span>
                            </>
                          ) : (
                            "No training information available"
                          )}
                        </MKTypography>
                        <MKTypography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                          Please complete the payment and then click the "Payment Complete" button.
                        </MKTypography>
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px', marginBottom: '10px' }}>
                          <MKButton variant="gradient" color="info" size="small" onClick={() => onPaymentCompletedClick(trainerWithStatus9[0])} style={{ padding: '5px 10px' }}>Payment Completed</MKButton>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <MKTypography style={{ fontSize: 'medium', marginLeft: '20px', marginBottom: '10px' }}>
                            In case of any issues, please reach us at support@labasservice.com
                          </MKTypography>
                        </div>
                      </MKBox>
                    </Modal>
                  </>
                )}
                {feedbackStatusAvailable && (
                  <>
                    <Modal open={feedbackStatusAvailable === true} onClose={() => setShowFeedbackModal(false)} sx={{ display: "grid", placeItems: "center" }}>
                      <MKBox
                        position="relative"
                        width="830px"
                        display="flex"
                        flexDirection="column"
                        borderRadius="xl"
                        bgColor="white"
                        shadow="xl"
                      >
                        <div style={{ maxHeight: '90vh', overflowY: 'auto' }}>
                          <h2 style={{ whiteSpace: 'nowrap', fontSize: 'large', marginLeft: '10px', marginTop: '10px' }}>
                            {trainerWithStatus7 ? (
                              <>
                                <span>Feedback for the&nbsp;
                                  <strong style={{ fontWeight: 'bold' }}>
                                    {trainerWithStatus7.apply_training.selectedTrainingName}
                                  </strong>&nbsp;Training for the Trainer -&nbsp;
                                  <strong style={{ fontWeight: 'bold' }}>
                                    {trainerWithStatus7.firstName}&nbsp;{trainerWithStatus7.lastName}
                                  </strong>&nbsp;
                                </span>
                              </>
                            ) : (
                              "No training information available"
                            )}
                          </h2>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <MKTypography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                              Share your feedback by providing a rating for the trainer's performance * -
                            </MKTypography>
                            <Stack spacing={1} style={{ marginLeft: '20px', marginTop: '10px' }}>
                              <Rating
                                name="half-rating"
                                value={feedbackRating}
                                precision={0.5}
                                onChange={handleRatingChange}
                              />
                            </Stack>
                          </div>
                          <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                            {feedbackQuestions.length > 0 && feedbackQuestions[0].question}
                          </Typography>
                          <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                            <div>
                              <TextField
                                label="Min: 10 characters, Max: 500 characters"
                                multiline
                                rows={4}
                                variant="outlined"
                                style={{
                                  width: '650px', marginLeft: "20px",
                                  borderColor: feedbackAnswer1.length >= 10 && feedbackAnswer1.length <= 500 && isFeedback1Interacted
                                    ? "initial"
                                    : "initial",
                                }}
                                value={feedbackAnswer1}
                                error={isFeedback1Interacted && (feedbackAnswer1.length < 10 || feedbackAnswer1.length > 500)}
                                helperText={
                                  isFeedback1Interacted && (feedbackAnswer1.length < 10 || feedbackAnswer1.length > 500)
                                    ? ""
                                    : ""
                                }
                                onChange={(e) => {
                                  setFeedbackAnswer1(e.target.value);
                                }}
                                onFocus={() => setIsFeedback1Interacted(true)}
                              />
                            </div>
                          </Grid>
                          <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                            {feedbackQuestions.length > 0 && feedbackQuestions[1].question}
                          </Typography>
                          <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                            <div>
                              <TextField
                                label="Min: 10 characters, Max: 500 characters"
                                multiline
                                rows={4}
                                variant="outlined"
                                style={{
                                  width: '650px', marginLeft: "20px",
                                  borderColor: feedbackAnswer2.length >= 10 && feedbackAnswer2.length <= 500 && isFeedback2Interacted
                                    ? "initial"
                                    : "initial",
                                }}
                                value={feedbackAnswer2}
                                // fullWidth
                                error={isFeedback2Interacted && (feedbackAnswer2.length < 10 || feedbackAnswer2.length > 500)}
                                helperText={
                                  isFeedback2Interacted && (feedbackAnswer2.length < 10 || feedbackAnswer2.length > 500)
                                    ? ""
                                    : ""
                                }
                                onChange={(e) => {
                                  setFeedbackAnswer2(e.target.value);
                                }}
                                onFocus={() => setIsFeedback2Interacted(true)}
                              />
                            </div>
                          </Grid>
                          <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                            {feedbackQuestions.length > 0 && feedbackQuestions[2].question}
                          </Typography>
                          <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                            <div>
                              <TextField
                                label="Min: 10 characters, Max: 500 characters"
                                multiline
                                rows={4}
                                variant="outlined"
                                style={{
                                  width: '650px', marginLeft: "20px",
                                  borderColor: feedbackAnswer3.length >= 10 && feedbackAnswer3.length <= 500 && isFeedback3Interacted
                                    ? "initial"
                                    : "initial",
                                }}
                                value={feedbackAnswer3}
                                // fullWidth
                                error={isFeedback3Interacted && (feedbackAnswer3.length < 10 || feedbackAnswer3.length > 500)}
                                helperText={
                                  isFeedback3Interacted && (feedbackAnswer3.length < 10 || feedbackAnswer3.length > 500)
                                    ? ""
                                    : ""
                                }
                                onChange={(e) => {
                                  setFeedbackAnswer3(e.target.value);
                                }}
                                onFocus={() => setIsFeedback3Interacted(true)}
                              />
                            </div>
                          </Grid>
                          <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                            {feedbackQuestions.length > 0 && feedbackQuestions[3].question}
                          </Typography>
                          <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                            <div>
                              <TextField
                                label="Min: 10 characters, Max: 500 characters"
                                multiline
                                rows={4}
                                variant="outlined"
                                style={{
                                  width: '650px', marginLeft: "20px",
                                  borderColor: feedbackAnswer4.length >= 10 && feedbackAnswer4.length <= 500 && isFeedback4Interacted
                                    ? "initial"
                                    : "initial",
                                }}
                                value={feedbackAnswer4}
                                // fullWidth
                                error={isFeedback4Interacted && (feedbackAnswer4.length < 10 || feedbackAnswer4.length > 500)}
                                helperText={
                                  isFeedback2Interacted && (feedbackAnswer4.length < 10 || feedbackAnswer4.length > 500)
                                    ? ""
                                    : ""
                                }
                                onChange={(e) => {
                                  setFeedbackAnswer4(e.target.value);
                                }}
                                onFocus={() => setIsFeedback4Interacted(true)}
                              />
                            </div>
                          </Grid><Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                            {feedbackQuestions.length > 0 && feedbackQuestions[4].question}
                          </Typography>
                          <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                            <div>
                              <TextField
                                label="Min: 10 characters, Max: 500 characters"
                                multiline
                                rows={4}
                                variant="outlined"
                                style={{
                                  width: '650px', marginLeft: "20px",
                                  borderColor: feedbackAnswer5.length >= 10 && feedbackAnswer5.length <= 500 && isFeedback5Interacted
                                    ? "initial"
                                    : "initial",
                                }}
                                value={feedbackAnswer5}
                                // fullWidth
                                error={isFeedback5Interacted && (feedbackAnswer5.length < 10 || feedbackAnswer5.length > 500)}
                                helperText={
                                  isFeedback5Interacted && (feedbackAnswer5.length < 10 || feedbackAnswer5.length > 500)
                                    ? ""
                                    : ""
                                }
                                onChange={(e) => {
                                  setFeedbackAnswer5(e.target.value);
                                }}
                                onFocus={() => setIsFeedback5Interacted(true)}
                              />
                            </div>
                          </Grid>
                          <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                            {feedbackQuestions.length > 0 && feedbackQuestions[5].question}
                          </Typography>
                          <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                            <div>
                              <TextField
                                label="Min: 10 characters, Max: 500 characters"
                                multiline
                                rows={4}
                                variant="outlined"
                                style={{
                                  width: '650px', marginLeft: "20px",
                                  borderColor: feedbackAnswer6.length >= 10 && feedbackAnswer6.length <= 500 && isFeedback6Interacted
                                    ? "initial"
                                    : "initial",
                                }}
                                value={feedbackAnswer6}
                                // fullWidth
                                error={isFeedback6Interacted && (feedbackAnswer6.length < 10 || feedbackAnswer6.length > 500)}
                                helperText={
                                  isFeedback6Interacted && (feedbackAnswer6.length < 10 || feedbackAnswer6.length > 500)
                                    ? ""
                                    : ""
                                }
                                onChange={(e) => {
                                  setFeedbackAnswer6(e.target.value);
                                }}
                                onFocus={() => setIsFeedback6Interacted(true)}
                              />
                            </div>
                          </Grid>
                          <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                            {feedbackQuestions.length > 0 && feedbackQuestions[6].question}
                          </Typography>
                          <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                            <div>
                              <TextField
                                label="Min: 10 characters, Max: 500 characters"
                                multiline
                                rows={4}
                                variant="outlined"
                                style={{
                                  width: '650px', marginLeft: "20px",
                                  borderColor: feedbackAnswer7.length >= 10 && feedbackAnswer7.length <= 500 && isFeedback7Interacted
                                    ? "initial"
                                    : "initial",
                                }}
                                value={feedbackAnswer7}
                                // fullWidth
                                error={isFeedback7Interacted && (feedbackAnswer7.length < 10 || feedbackAnswer7.length > 500)}
                                helperText={
                                  isFeedback7Interacted && (feedbackAnswer7.length < 10 || feedbackAnswer7.length > 500)
                                    ? ""
                                    : ""
                                }
                                onChange={(e) => {
                                  setFeedbackAnswer7(e.target.value);
                                }}
                                onFocus={() => setIsFeedback7Interacted(true)}
                              />
                            </div>
                          </Grid>
                          <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                            {feedbackQuestions.length > 0 && feedbackQuestions[7].question}
                          </Typography>
                          <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                            <div>
                              <TextField
                                label="Min: 10 characters, Max: 500 characters"
                                multiline
                                rows={4}
                                variant="outlined"
                                style={{
                                  width: '650px', marginLeft: "20px",
                                  borderColor: feedbackAnswer8.length >= 10 && feedbackAnswer8.length <= 500 && isFeedback8Interacted
                                    ? "initial"
                                    : "initial",
                                }}
                                value={feedbackAnswer8}
                                // fullWidth
                                error={isFeedback8Interacted && (feedbackAnswer8.length < 10 || feedbackAnswer8.length > 500)}
                                helperText={
                                  isFeedback8Interacted && (feedbackAnswer8.length < 10 || feedbackAnswer8.length > 500)
                                    ? ""
                                    : ""
                                }
                                onChange={(e) => {
                                  setFeedbackAnswer8(e.target.value);
                                }}
                                onFocus={() => setIsFeedback8Interacted(true)}
                              />
                            </div>
                          </Grid>
                          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
                            <MKButton variant="gradient" color="info" size="small" disabled={!feedbackRating || !feedbackAnswer1 || feedbackAnswer1.length < 10 || feedbackAnswer1.length > 500
                              || !feedbackAnswer2 || feedbackAnswer2.length < 10 || feedbackAnswer2.length > 500
                              || !feedbackAnswer3 || feedbackAnswer3.length < 10 || feedbackAnswer3.length > 500
                              || !feedbackAnswer4 || feedbackAnswer4.length < 10 || feedbackAnswer4.length > 500
                              || !feedbackAnswer5 || feedbackAnswer5.length < 10 || feedbackAnswer5.length > 500
                              || !feedbackAnswer6 || feedbackAnswer6.length < 10 || feedbackAnswer6.length > 500
                              || !feedbackAnswer7 || feedbackAnswer7.length < 10 || feedbackAnswer7.length > 500
                              || !feedbackAnswer8 || feedbackAnswer8.length < 10 || feedbackAnswer8.length > 500}
                              onClick={() => onSubmitFeebackClick(trainerWithStatus7)} style={{ padding: '5px 10px' }}>Submit Feedback</MKButton>
                          </div>
                        </div>
                      </MKBox>
                    </Modal>
                  </>
                )}
                {paymentNotReceivedModal && (
                  <>
                    <Modal open={paymentNotReceivedModal} sx={{ display: "grid", placeItems: "center" }}>
                      <MKBox
                        position="relative"
                        width="650px"
                        display="flex"
                        flexDirection="column"
                        borderRadius="xl"
                        bgColor="white"
                        shadow="xl"
                      >
                        <h2 style={{ display: 'flex', justifyContent: 'center', whiteSpace: 'nowrap', fontSize: 'large', marginLeft: '10px', marginTop: '10px' }}>
                          Attention !
                        </h2>
                        <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                          It looks like the payment hasn't been received by the trainer - &nbsp;<strong>{trainerStatus12[0].firstName} {trainerStatus12[0].lastName}.</strong>
                        </MKTypography>
                        <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                          Please review the transaction, and if there are any issues, reach out for assistance.
                        </MKTypography>
                        <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                          Thank you for your attention to this matter.
                        </MKTypography>
                        <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                          If the payment transaction is successfull , Please click on &nbsp;<strong>"Payment Completed"</strong>.
                        </MKTypography>
                        <div style={{ display: 'flex', justifyContent: 'center', marginRight: '10px', marginBottom: '10px', marginTop: "10px" }}>
                          <MKButton variant="gradient" color="info" size="small" disabled={expectedNewPaymentDate !== ""} onClick={() => onNewPaymentCompletedClick(trainerStatus12)} style={{ padding: '5px 10px' }}>Paymemt Completed</MKButton>
                        </div>
                        <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                          If you wish to submit a new payment date, please click on
                        </MKTypography>
                        <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                          <strong>"Submit New Payment Date"</strong>&nbsp; and select a date and proceed accordingly.
                        </MKTypography>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10px' }}>
                          <MKTypography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                            Expected New Payment Date * :
                          </MKTypography>
                          <MKInput
                            type="date"
                            id="expected_newPaymentDate"
                            style={{ marginLeft: '20px', width: '200px' }}
                            value={expectedNewPaymentDate || ""}
                            onChange={handleExpectedNewPaymentDateChange}
                            placeholder={expectedNewPaymentDate ? "" : "Expected New Payment Date"}
                            inputProps={{ min: today, max: maxDateString }}
                          // fullwidth
                          />
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px', marginTop: '10px' }}>
                          <MKButton variant="gradient" color="info" size="small" disabled={expectedNewPaymentDate === ""} onClick={() => onSubmitNewPaymentClick(trainerStatus12)} style={{ padding: '5px 10px' }}>Submit New Payment Date </MKButton>
                        </div>
                        <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium', marginLeft: '20px', marginBottom: '20px', marginTop: '10px' }}>
                          In case of any issues, please reach us at support@labasservice.com
                        </MKTypography>
                      </MKBox>
                    </Modal>
                  </>
                )}
                {waitingTrainingConfirmation && (
                  <>
                    <Modal open={waitingTrainingConfirmation} sx={{ display: "grid", placeItems: "center" }}>
                      <MKBox
                        position="relative"
                        width="580px"
                        display="flex"
                        flexDirection="column"
                        borderRadius="xl"
                        bgColor="white"
                        shadow="xl"
                      >
                        <h2 style={{ whiteSpace: 'nowrap', fontSize: 'large', marginLeft: '10px', marginTop: '10px' }}>
                          Alert!
                        </h2>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                          <MKTypography style={{ fontSize: 'medium', marginLeft: '20px' }}>
                            {(trainerStatus20.length > 0 || trainerExceededPayment.length > 0) ? (
                              `Kindly await confirmation from Trainer - ${(trainerStatus20.length > 0 ? `${trainerStatus20[0].firstName || ''} ${trainerStatus20[0].lastName || ''}` : '')} ${(trainerExceededPayment.length > 0 ? `${trainerExceededPayment[0].firstName || ''} ${trainerExceededPayment[0].lastName || ''}` : '')} regarding your payment.`
                            ) : (
                              "No trainer information available"
                            )}
                          </MKTypography>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                          <Typography style={{ fontSize: 'medium', marginLeft: '20px' }}>
                            Access to Collab will be granted upon confirmation of payment by the trainer.
                          </Typography>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                          <Typography style={{ fontSize: 'medium', marginLeft: '20px' }}>
                            Thank you for your patience!
                          </Typography>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                          <MKTypography style={{ fontSize: 'medium', marginLeft: '20px', marginBottom: '10px' }}>
                            In case of any issues, please reach us at support@labasservice.com
                          </MKTypography>
                        </div>
                      </MKBox>
                    </Modal>
                  </>
                )}
                {paymentExceededModal && (
                  <>
                    <Modal open={paymentExceededModal} sx={{ display: "grid", placeItems: "center" }}>
                      <MKBox
                        position="relative"
                        width="580px"
                        display="flex"
                        flexDirection="column"
                        borderRadius="xl"
                        bgColor="white"
                        shadow="xl"
                      >
                        <h2 style={{ whiteSpace: 'nowrap', fontSize: 'large', marginLeft: '10px', marginTop: '10px' }}>
                          {trainerExceededPayment.length > 0 ? (
                            `Take the final step!`
                          ) : (
                            "No trainer information available"
                          )}
                        </h2>
                        <MKTypography variant="body1" style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                          {trainerExceededPayment.length > 0 ? (
                            `Complete the Payment for the Training - ${trainerExceededPayment[0].apply_training.selectedTrainingName}`
                          ) : (
                            "No trainer information available"
                          )}
                        </MKTypography>
                        <MKTypography variant="body1" style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                          As this is final attempt, please upload payment proof
                        </MKTypography>
                        <MKTypography variant="body1" style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                          Note : Payment Proof file should be in .jpeg /.jpg /.png /.pdf format with maximum size of 300kb
                        </MKTypography>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                          <MKTypography style={{ fontSize: 'medium', marginLeft: '20px' }}>
                            Upload Payment Proof *
                          </MKTypography>
                          <input
                            type="file"
                            id="paymentProof-upload"
                            accept="pdf/*"
                            style={{ display: 'none' }}
                            ref={paymentProofFileInputRef}
                            onChange={handlePaymentProofUploadChange}
                          />
                          <div style={{ display: 'flex', alignItems: 'center', marginLeft: '20px' }}>
                            <label htmlFor="resume-upload">
                              <MKButton onClick={handleUploadClick} variant="gradient" color="info" size="small">
                                Upload
                              </MKButton>
                            </label>
                            {paymentProof && (
                              <>
                                <div style={{ fontSize: '14px', marginLeft: "10px" }}>
                                  <span>{paymentProof.name}</span>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                        {error && (
                          <MKTypography style={{ color: 'red', fontSize: 'small', marginLeft: '20px', marginTop: '5px' }}>
                            {error}
                          </MKTypography>
                        )}
                        <MKTypography variant="body1" style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                          Please complete the payment and then click the "Payment Complete" button.
                        </MKTypography>
                        <div style={{ display: 'flex', justifyContent: 'center', marginRight: '10px' }}>
                          <MKButton variant="gradient" color="info" size="small" onClick={() => onFinalPaymentCompletedClick(trainerExceededPayment[0])} disabled={!fileUploaded || error} style={{ padding: '5px 10px' }}>
                            Payment Completed
                          </MKButton>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                          <MKTypography style={{ fontSize: 'medium', marginLeft: '20px', marginBottom: '10px' }}>
                            In case of any issues, please reach us at support@labasservice.com
                          </MKTypography>
                        </div>
                      </MKBox>
                    </Modal>
                  </>
                )}
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Grid container spacing={2} style={{ marginBottom: "10px" }}>
                    <Grid item xs={12} style={{ display: 'flex' }}>
                      <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h4" color="text">
                        <span style={{ color: 'black' }}>Posted</span>{' '}
                        <span style={{ color: '#2e1114' }}>Trainings</span>
                      </MKTypography>
                    </Grid>
                  </Grid>
                  {Array.isArray(postedTrainingDetails) && postedTrainingDetails.length === 0 ? (
                    <span style={{ marginLeft: "35px", marginBottom: "20px", fontSize: 'medium' }}>No Trainings has been posted yet</span>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                        <Icon onClick={() => handlePostedScroll('left')}>keyboard_arrow_left</Icon>
                        <div
                          id="posted-training-list-container"
                          style={{
                            display: 'flex',
                            overflowX: 'hidden', // Hide the scrollbar but allow scrolling
                            scrollBehavior: 'smooth',
                            padding: '10px',
                            width: '100%',
                            position: 'relative', // Add relative position to container
                          }}
                        >
                          {postedTrainingDetails
                            .slice(postedCurrentSlide * 2, postedCurrentSlide * 2 + 2)
                            .map((training, index) => (
                              // {postedTrainingDetails.slice(0, 5).map((training, index) => (
                              <div key={index} style={{ flex: '0 0 auto', marginRight: '20px', marginTop: '-10px', width: '49%' }}>
                                <Grid item xs={12} key={training.id} className="gridItemTC">
                                  <div className="gridContent">
                                    <div className="trainingInfo">
                                      <MKTypography variant="subtitle1" className="trainingName"><strong>{training[0].trainingName}</strong></MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <img src={Logo} alt="Skills Logo" style={{ whiteSpace: 'nowrap', marginRight: '5px', width: '20px', height: '20px' }} /> {training[0].displaySkills}
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <img src={CompanyIcon} alt="Company Icon" style={{ marginRight: '5px', width: '20px', height: '20px' }} />{training[0].trainingCompanyName}
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <LocationOn style={{ marginRight: '5px' }} /> {training[0].trainingMode}
                                          {training[0].trainingMode === 'Classroom' ? ` | ${training[0].trainingLocations}` : ''}
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          {training[0].currency}&nbsp;{training[0].totalTrainingBudget} |&nbsp;<img src={Expectation} alt="Expectation Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training[0].trainingExpectation}
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <CalendarMonthIcon style={{ marginRight: '5px' }} /> {training[0].expectedStartDate}
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong> Status: {getStatusMessage(training[0])} </strong>
                                        </span>
                                      </MKTypography>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-40px' }}>
                                      <MKButton variant="gradient" color="info" size="small" onClick={() => onActiveTrainingMoreDetails(training[0])} style={{ padding: '5px 10px' }}>Details</MKButton>
                                    </div>
                                  </div>
                                </Grid>
                              </div>
                            ))}
                          {/* {renderTrainingCards()} */}
                          {(postedTrainingDetails.length >= 1) && (
                            <div key="see-more-card" style={{ flex: '0 0 auto', marginRight: '20px', marginTop: '-10px', width: '49%' }}>
                              <Grid item xs={12} className="gridItemTC">
                                <div className="gridContent">
                                  <div className="trainingInfo">
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      <a href="/app/postedtrainingseemore" style={{ color: 'blue', textDecoration: 'underline' }}>
                                        See More
                                      </a>
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                  </div>
                                </div>
                              </Grid>
                            </div>
                          )}
                        </div>
                        <Icon onClick={() => handlePostedScroll('right')}>keyboard_arrow_right</Icon>
                      </div>
                    </div>
                  )}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Grid container spacing={2} style={{ marginBottom: "10px" }}>
                    <Grid item xs={12} style={{ display: 'flex' }}>
                      <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h4" color="text">
                        <span style={{ color: 'black' }}>Active</span>{' '}
                        <span style={{ color: '#2e1114' }}>Trainings</span>
                      </MKTypography>
                    </Grid>
                  </Grid>
                  {Array.isArray(appliedTrainingDetails) && appliedTrainingDetails.length === 0 ? (
                    <span style={{ marginLeft: "35px", marginBottom: "20px", fontSize: 'medium' }}>There is no Active Trainings</span>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                        <Icon onClick={() => handleActiveScroll('left')}>keyboard_arrow_left</Icon>
                        <div
                          id="active-training-list-container"
                          style={{
                            display: 'flex',
                            overflowX: 'hidden', // Hide the scrollbar but allow scrolling
                            scrollBehavior: 'smooth',
                            padding: '10px',
                            width: '100%',
                            position: 'relative', // Add relative position to container
                          }}
                        >
                          {appliedTrainingDetails
                            .slice(activeCurrentSlide * 2, activeCurrentSlide * 2 + 2)
                            .map((training, index) => (
                              // {appliedTrainingDetails.slice(0, 5).map((training, index) => (
                              <div key={index} style={{ flex: '0 0 auto', marginRight: '20px', marginTop: '-10px', width: '49%' }}>
                                <Grid item xs={12} key={training[0].id} className="gridItemTC">
                                  <div className="gridContent">
                                    <div className="trainingInfo">
                                      <MKTypography variant="subtitle1" className="trainingName"><strong>{training[0].trainingName}</strong></MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <img src={Logo} alt="Skills Logo" style={{ whiteSpace: 'nowrap', marginRight: '5px', width: '20px', height: '20px' }} /> {training[0].displaySkills}
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <img src={CompanyIcon} alt="Company Icon" style={{ marginRight: '5px', width: '20px', height: '20px' }} />{training[0].trainingCompanyName}
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <LocationOn style={{ marginRight: '5px' }} /> {training[0].trainingMode}
                                          {training[0].trainingMode === 'Classroom' ? ` | ${training[0].trainingLocations}` : ''}
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          {training[0].currency}&nbsp;{training[0].totalTrainingBudget} |&nbsp;<img src={Expectation} alt="Expectation Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training[0].trainingExpectation}
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <CalendarMonthIcon style={{ marginRight: '5px' }} /> {training[0].expectedStartDate}
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong> Status: {getStatusMessage(training[0])} </strong>
                                        </span>
                                      </MKTypography>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-40px' }}>
                                      <MKButton variant="gradient" color="info" size="small" onClick={() => onActiveTrainingMoreDetails(training[0])} style={{ padding: '5px 10px' }}>Details</MKButton>
                                    </div>
                                  </div>
                                </Grid>
                              </div>
                            ))}
                          {(appliedTrainingDetails.length >= 1) && (
                            <div key="see-more-card" style={{ flex: '0 0 auto', marginRight: '20px', marginTop: '-10px', width: '49%' }}>
                              <Grid item xs={12} className="gridItemTC">
                                <div className="gridContent">
                                  <div className="trainingInfo">
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      <a href="/app/activetrainingseemore" style={{ color: 'blue', textDecoration: 'underline' }}>
                                        See More
                                      </a>
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                  </div>
                                </div>
                              </Grid>
                            </div>
                          )}
                        </div>
                        <Icon onClick={() => handleActiveScroll('right')}>keyboard_arrow_right</Icon>
                      </div>
                    </div>
                  )}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Grid container spacing={2} style={{ marginBottom: "10px" }}>
                    <Grid item xs={12} style={{ display: 'flex' }}>
                      <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h4" color="text">
                        <span style={{ color: 'black' }}>Completed</span>{' '}
                        <span style={{ color: '#2e1114' }}>Trainings</span>
                      </MKTypography>
                    </Grid>
                  </Grid>
                  {Array.isArray(completedTrainingDetails) && completedTrainingDetails.length === 0 ? (
                    <span style={{ marginLeft: "35px", marginBottom: "20px", fontSize: 'medium' }}>No Training has been completed yet</span>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                        <Icon onClick={() => handleCompletedScroll('left')}>keyboard_arrow_left</Icon>
                        <div
                          id="completed-training-list-container"
                          style={{
                            display: 'flex',
                            overflowX: 'hidden', // Hide the scrollbar but allow scrolling
                            scrollBehavior: 'smooth',
                            padding: '10px',
                            width: '100%',
                            position: 'relative', // Add relative position to container
                          }}
                        >
                          {completedTrainingDetails
                            .slice(completedCurrentSlide * 2, completedCurrentSlide * 2 + 2)
                            .map((training, index) => (
                              // {completedTrainingDetails.slice(0, 5).map((training, index) => (
                              <div key={index} style={{ flex: '0 0 auto', marginRight: '20px', marginTop: '-10px', width: '49%' }}>
                                <Grid item xs={12} key={training.id} className="gridItemTC">
                                  <div className="gridContent">
                                    <div className="trainingInfo">
                                      <MKTypography variant="subtitle1" className="trainingName"><strong>{training[0].trainingName}</strong></MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <img src={Logo} alt="Skills Logo" style={{ whiteSpace: 'nowrap', marginRight: '5px', width: '20px', height: '20px' }} /> {training[0].displaySkills}
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <img src={CompanyIcon} alt="Company Icon" style={{ marginRight: '5px', width: '20px', height: '20px' }} />{training[0].trainingCompanyName}
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <LocationOn style={{ marginRight: '5px' }} /> {training[0].trainingMode}
                                          {training[0].trainingMode === 'Classroom' ? ` | ${training[0].trainingLocations}` : ''}
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          {training[0].currency}&nbsp;{training[0].totalTrainingBudget} |&nbsp;<img src={Expectation} alt="Expectation Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training[0].trainingExpectation}
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <CalendarMonthIcon style={{ marginRight: '5px' }} /> {training[0].expectedStartDate}
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong> Status: {getStatusMessage(training[0])} </strong>
                                        </span>
                                      </MKTypography>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-40px' }}>
                                      <MKButton variant="gradient" color="info" size="small" onClick={() => onActiveTrainingMoreDetails(training[0])} style={{ padding: '5px 10px' }}>Details</MKButton>
                                    </div>
                                  </div>
                                </Grid>
                              </div>
                            ))}
                          {(completedTrainingDetails.length >= 1) && (
                            <div key="see-more-card" style={{ flex: '0 0 auto', marginRight: '20px', marginTop: '-10px', width: '49%' }}>
                              <Grid item xs={12} className="gridItemTC">
                                <div className="gridContent">
                                  <div className="trainingInfo">
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      <a href="/app/completedtrainingseemore" style={{ color: 'blue', textDecoration: 'underline' }}>
                                        See More
                                      </a>
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                  </div>
                                </div>
                              </Grid>
                            </div>
                          )}
                        </div>
                        <Icon onClick={() => handleCompletedScroll('right')}>keyboard_arrow_right</Icon>
                      </div>
                    </div>
                  )}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Grid container spacing={2} style={{ marginBottom: "10px" }}>
                    <Grid item xs={12} style={{ display: 'flex' }}>
                      <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h4" color="text">
                        <span style={{ color: 'black' }}>Cancelled</span>{' '}
                        <span style={{ color: '#2e1114' }}>Trainings</span>
                      </MKTypography>
                    </Grid>
                  </Grid>
                  {Array.isArray(cancelledTrainingDetails) && cancelledTrainingDetails.length === 0 ? (
                    <span style={{ marginLeft: "35px", marginBottom: "20px", fontSize: 'medium' }}>No Training has been cancelled</span>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                        <Icon onClick={() => handleCancelledScroll('left')}>keyboard_arrow_left</Icon>
                        <div
                          id="cancelled-training-list-container"
                          style={{
                            display: 'flex',
                            overflowX: 'hidden', // Hide the scrollbar but allow scrolling
                            scrollBehavior: 'smooth',
                            padding: '10px',
                            width: '100%',
                            position: 'relative', // Add relative position to container
                          }}
                        >
                          {cancelledTrainingDetails
                            .slice(cancelledCurrentSlide * 2, cancelledCurrentSlide * 2 + 2)
                            .map((training, index) => (
                              // {cancelledTrainingDetails.slice(0, 5).map((training, index) => (
                              <div key={index} style={{ flex: '0 0 auto', marginRight: '20px', marginTop: '-10px', width: '49%' }}>
                                <Grid item xs={12} key={training[0].id} className="gridItemTC">
                                  <div className="gridContent">
                                    <div className="trainingInfo">
                                      <MKTypography variant="subtitle1" className="trainingName"><strong>{training[0].trainingName}</strong></MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <img src={Logo} alt="Skills Logo" style={{ whiteSpace: 'nowrap', marginRight: '5px', width: '20px', height: '20px' }} /> {training[0].displaySkills}
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <img src={CompanyIcon} alt="Company Icon" style={{ marginRight: '5px', width: '20px', height: '20px' }} />{training[0].trainingCompanyName}
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <LocationOn style={{ marginRight: '5px' }} /> {training[0].trainingMode}
                                          {training[0].trainingMode === 'Classroom' ? ` | ${training[0].trainingLocations}` : ''}
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          {training[0].currency}&nbsp;{training[0].totalTrainingBudget} |&nbsp;<img src={Expectation} alt="Expectation Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training[0].trainingExpectation}
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <CalendarMonthIcon style={{ marginRight: '5px' }} /> {training[0].expectedStartDate}
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong> Status: {getStatusMessage(training[0])} </strong>
                                        </span>
                                      </MKTypography>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-40px' }}>
                                      <MKButton variant="gradient" color="info" size="small" onClick={() => onActiveTrainingMoreDetails(training[0])} style={{ padding: '5px 10px' }}>Details</MKButton>
                                    </div>
                                  </div>
                                </Grid>
                              </div>
                            ))}
                          {(cancelledTrainingDetails.length >= 1) && (
                            <div key="see-more-card" style={{ flex: '0 0 auto', marginRight: '20px', marginTop: '-10px', width: '49%' }}>
                              <Grid item xs={12} className="gridItemTC">
                                <div className="gridContent">
                                  <div className="trainingInfo">
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      <a href="/app/cancelledtrainingseemore" style={{ color: 'blue', textDecoration: 'underline' }}>
                                        See More
                                      </a>
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                  </div>
                                </div>
                              </Grid>
                            </div>
                          )}
                        </div>
                        <Icon onClick={() => handleCancelledScroll('right')}>keyboard_arrow_right</Icon>
                      </div>
                    </div>
                  )}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Grid container spacing={2} style={{ marginBottom: "10px" }}>
                    <Grid item xs={12} style={{ display: 'flex' }}>
                      <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h4" color="text">
                        <span style={{ color: 'black' }}>Recurited</span>{' '}
                        <span style={{ color: '#2e1114' }}>Trainers</span>
                      </MKTypography>
                    </Grid>
                  </Grid>
                  {trainerRecruitDetails.length === 0 ? (
                    <span style={{ marginLeft: "35px", marginBottom: "20px", fontSize: 'medium' }}>You have not recruited any trainer at the moment.</span>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                        <Icon onClick={() => handleRecuritScroll('left')}>keyboard_arrow_left</Icon>
                        <div
                          id="recurit-training-list-container"
                          style={{
                            display: 'flex',
                            overflowX: 'hidden', // Hide the scrollbar but allow scrolling
                            scrollBehavior: 'smooth',
                            padding: '10px',
                            width: '100%',
                            position: 'relative', // Add relative position to container
                          }}
                        >
                          {trainerRecruitDetails
                            .slice(recruitCurrentSlide * 2, recruitCurrentSlide * 2 + 2)
                            .map((trainer, index) => (
                              // {trainerRecruitDetails.slice(0, 5).map((trainer, index) => (
                              <div key={index} style={{ flex: '0 0 auto', marginRight: '20px', marginTop: '-10px', width: '49%' }}>
                                <Grid item xs={12} key={trainer.id} className="gridItemRecuritedTC" >
                                  <div className="gridContent">
                                    <div className="trainingInfo">
                                      <div style={{ fontWeight: 'bold', marginTop: '-5px', marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
                                        <MKAvatar
                                          src={`${process.env.REACT_APP_API_URL}${trainer.profilePictureName}/`}
                                          alt="Profile Picture"
                                          size="lg"
                                          style={{ backgroundColor: avatarBackgroundColor, marginRight: '10px' }}
                                        />
                                        <MKTypography variant="subtitle1" className="trainingName" style={{ marginTop: '5px' }}>
                                          <strong>{trainer.firstName}&nbsp;{trainer.lastName}</strong>
                                        </MKTypography>
                                      </div>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong><img src={Logo} alt="Skills Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /></strong> {trainer.displaySkills}
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <LocationOn style={{ marginRight: '5px' }} /> {trainer.currentLocationCountry} | {trainer.currentLocationState}  | {trainer.location}
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong style={{ marginLeft: "5px" }}>Total Experience :&nbsp;</strong>{trainer.totalExperience} months
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong style={{ marginLeft: "5px" }}>Avg per hour Commercial :&nbsp;</strong>{trainer.currency}&nbsp;{trainer.avgCommercialFor8hrs}
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong style={{ marginLeft: '5px', marginBottom: '-3px' }}>Rating</strong>&nbsp;
                                          <Stack spacing={1} style={{ marginLeft: '5px' }}>
                                            <Rating
                                              name="read-only"
                                              value={trainer.trainerRating}
                                              precision={0.5}
                                              readOnly
                                            />
                                          </Stack>
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <strong style={{ marginLeft: '5px' }} >Status:&nbsp;{getStatus(trainer.trainingCompanyRecruitStatus, trainer.trainerAcceptStatus, trainer.trainingCompanyAgreeStatus)}</strong>
                                      </MKTypography>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                                      <MKButton variant="gradient" color="info" size="small" onClick={() => onRecruitedTrainerMoreDetails(trainer)} style={{ padding: '5px 10px' }}>Details</MKButton>
                                    </div>
                                    {getStatus(trainer.trainingCompanyRecruitStatus, trainer.trainerAcceptStatus, trainer.trainingCompanyAgreeStatus) === "Awaiting For Trainer's response" && (
                                      <>
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                          <MKButton variant="gradient" color="info" size="small" onClick={() => onRemainderClick(trainer)} style={{ padding: '5px 10px' }}>Send Remainder</MKButton>
                                        </div>
                                      </>
                                    )}
                                    {getStatus(trainer.trainingCompanyRecruitStatus, trainer.trainerAcceptStatus, trainer.trainingCompanyAgreeStatus) === "Trainer - Accepted. Awaiting for your response" && (
                                      <>
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                          <MKButton variant="gradient" color="info" size="small" onClick={() => onAgreeClick(trainer)} style={{ padding: '5px 10px' }}>Accept</MKButton>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </Grid>
                              </div>
                            ))}
                          {(trainerRecruitDetails.length >= 1) && (
                            <div key="see-more-card" style={{ flex: '0 0 auto', marginRight: '20px', marginTop: '-10px', width: '49%' }}>
                              <Grid item xs={12} className="gridItemRecuritedTC">
                                <div className="gridContent">
                                  <div className="trainingInfo">
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      <a href="/app/recruitedtrainerseemore" style={{ color: 'blue', textDecoration: 'underline' }}>
                                        See More
                                      </a>
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                  </div>
                                </div>
                              </Grid>
                            </div>
                          )}
                        </div>
                        <Icon onClick={() => handleRecuritScroll('right')}>keyboard_arrow_right</Icon>
                      </div>
                    </div>
                  )}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Grid container spacing={2} style={{ marginBottom: "20px" }}>
                    <Grid item xs={12} style={{ display: 'flex' }}>
                      <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h4" color="text">
                        <span style={{ color: 'black' }}>Recommended</span>{' '}
                        <span style={{ color: '#2e1114' }}>Trainers</span>
                      </MKTypography>
                    </Grid>
                  </Grid>
                  {recommendedSkillsDetails.length === 0 ? (
                    <span style={{ marginLeft: "35px", marginBottom: "20px", fontSize: 'medium' }}>Enhance your profile for personalized trainer recommendations.</span>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                        <Icon onClick={() => handleRecommendedScroll('left')}>keyboard_arrow_left</Icon>
                        <div
                          id="recommended-training-list-container"
                          style={{
                            display: 'flex',
                            overflowX: 'hidden', // Hide the scrollbar but allow scrolling
                            scrollBehavior: 'smooth',
                            padding: '10px',
                            width: '100%',
                            position: 'relative', // Add relative position to container
                          }}
                        >
                          {/* {recommendedSkillsDetails.slice(0, 5).map((trainer, index) => ( */}
                          {recommendedSkillsDetails
                            .slice(recommendedCurrentSlide * 2, recommendedCurrentSlide * 2 + 2)
                            .map((trainer, index) => (
                              <div key={index} style={{ flex: '0 0 auto', marginRight: '20px', marginTop: '-10px', width: '49%' }}>
                                <Grid item xs={12} key={trainer.id} className="gridItemRecommendedTC">
                                  <div className="gridContent">
                                    <div className="trainingInfo">
                                      <div style={{ fontWeight: 'bold', marginTop: '-5px', marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
                                        <MKAvatar
                                          src={`${process.env.REACT_APP_API_URL}${trainer.profilePictureName}/`}
                                          alt="Profile Picture"
                                          size="lg"
                                          style={{ backgroundColor: avatarBackgroundColor, marginRight: '10px' }}
                                        />
                                        <MKTypography variant="subtitle1" className="trainingName" style={{ marginTop: '5px' }}>
                                          <strong>{trainer.firstName}&nbsp;{trainer.lastName}</strong>
                                        </MKTypography>
                                      </div>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <img src={Logo} alt="Skills Logo" style={{ whiteSpace: 'nowrap', marginRight: '5px', width: '20px', height: '20px' }} /> {trainer.displaySkills}
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <LocationOn style={{ marginRight: '5px' }} /> {trainer.currentLocationCountry} | {trainer.currentLocationState}  | {trainer.location}
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong style={{ marginLeft: "5px" }}>Total Experience :&nbsp;</strong>{trainer.totalExperience} months
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong style={{ marginLeft: "5px" }}>Avg per hour Commercial :&nbsp;</strong>{trainer.currency}&nbsp;{trainer.avgCommercialFor8hrs}
                                        </span>
                                      </MKTypography>
                                      <MKTypography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong style={{ marginLeft: '5px', marginBottom: '-3px' }}>Rating</strong>&nbsp;
                                          <Stack spacing={1} style={{ marginLeft: '5px' }}>
                                            <Rating
                                              name="read-only"
                                              value={trainer.trainerRating}
                                              precision={0.5}
                                              readOnly
                                            />
                                          </Stack>
                                        </span>
                                      </MKTypography>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                                      <MKButton variant="gradient" color="info" size="small" onClick={() => onSkillsMoreDetails(trainer)} style={{ padding: '5px 10px' }}>Details</MKButton>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                      <MKButton variant="gradient" color="info" size="small" onClick={() => onConnectClick(trainer)} style={{ padding: '5px 10px' }}>Connect</MKButton>
                                    </div>
                                  </div>
                                </Grid>
                              </div>
                            ))}
                          {(recommendedSkillsDetails.length >= 1) && (
                            <div key="see-more-card" style={{ flex: '0 0 auto', marginRight: '20px', marginTop: '-10px', width: '49%' }}>
                              <Grid item xs={12} className="gridItemRecommendedTC">
                                <div className="gridContent">
                                  <div className="trainingInfo">
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      <a href="/app/recommendedtrainerseemore" style={{ color: 'blue', textDecoration: 'underline' }}>
                                        See More
                                      </a>
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                  </div>
                                </div>
                              </Grid>
                            </div>
                          )}
                        </div>
                        <Icon onClick={() => handleRecommendedScroll('right')}>keyboard_arrow_right</Icon>
                      </div>
                    </div>
                  )}
                </div>
              </Grid>
            </Grid>
          </Container>
        </Card>
        <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <MKBox position="center" zIndex={2} style={{ bottom: 0 }}>
            <SimpleFooter />
          </MKBox>
        </div>
      </LoadingOverlay>
    </>
  );
};

export default Page;
